import { Connection } from '@/configuration/Connection';
const apiUrl = Connection.getApiUrl();
const currentVersion = 'v2';

export const TrackingActions = {
    Ticket: {
        VIEWED_SUBJECT: 'ticket.viewed-subject',
        LEFT_SUBJECT: 'ticket.left-subject',
        FOUND_SOLUTION: 'ticket.found-solution',
    },
};

export const GlobalOverlays = {
    HOME_ASSISTANT: 'AssistantDialog',
    TICKET_TYPE: 'AddNewTicketType',
    TICKET_CATEGORY: 'AddNewTicketCategory',
    TICKET_INQUIRY: 'AddNewTicketInquiry',
};

export const Actions = {
    // Dashboard:
    INITIALIZE_TENANT_LOG_SOCKET: 'TenantNotifications/INITIALIZE_TENANT_LOG_SOCKET',
    FETCH_DASHBOARD_NOTIFICATIONS: 'TenantNotifications/FETCH_DASHBOARD_NOTIFICATIONS',
    FETCH_TENANTS_NOTIFICATIONS_UNREAD_COUNT: 'TenantNotifications/FETCH_TENANTS_NOTIFICATIONS_UNREAD_COUNT',
    FETCH_TENANT_LOGS_NOTIFICATIONS: 'TenantNotifications/FETCH_TENANT_LOGS_NOTIFICATIONS',
    FETCH_TENANT_NOTIFICATION: 'TenantNotifications/FETCH_TENANT_NOTIFICATION',
    MARK_TENANT_NOTIFICATION_AS_SEEN: 'TenantNotifications/MARK_TENANT_NOTIFICATION_AS_SEEN',
    MARK_TENANT_ALL_NOTIFICATION_AS_SEEN: 'TenantNotifications/MARK_TENANT_ALL_NOTIFICATION_AS_SEEN',
    FETCH_TENANT_UPCOMING_EVENTS: 'TenantNotifications/FETCH_TENANT_UPCOMING_EVENTS',

    // Messages
    SEND_MESSAGE: 'Messages/SEND_MESSAGE',
    FETCH_CONVERSATIONS: 'Messages/FETCH_CONVERSATIONS',
    MARK_ACTIVE_CONVERSATION_AS_SEEN: 'Messages/MARK_ACTIVE_CONVERSATION_AS_SEEN',
    FETCH_CONVERSATION_PDF_PREVIEW: 'Messages/FETCH_CONVERSATION_PDF_PREVIEW',
    START_CONVERSATION_UPDATE_TIMER: 'Messages/START_CONVERSATION_UPDATE_TIMER',
    INITIALIZE_MESSAGE_SEARCH: 'Messages/INITIALIZE_MESSAGE_SEARCH',
    INITIALIZE_CONVERSATION_SOCKET: 'Messages/INITIALIZE_CONVERSATION_SOCKET',
    INITIALIZE_MESSAGE_CHANNEL_SOCKET: 'Messages/INITIALIZE_MESSAGE_CHANNEL_SOCKET',
    INITIALIZE_PROPERTY_CONVERSATION: 'Messages/INITIALIZE_PROPERTY_CONVERSATION',
    INITIALIZE_DIRECT_CONVERSATION: 'Messages/INITIALIZE_DIRECT_CONVERSATION',
    CHANGE_CONVERSATION_STATUS: 'Messages/CHANGE_CONVERSATION_STATUS',
    CHANGE_CONVERSATION_TITLE: 'Messages/CHANGE_CONVERSATION_TITLE',
    CONVERT_CONVERSATION_TICKET: 'Messages/CONVERT_CONVERSATION_TICKET',
    FETCH_CONVERT_TICKET_ALL_TYPES: 'Messages/FETCH_CONVERT_TICKET_ALL_TYPES',
    FETCH_CONVERT_TICKET_ALL_CATEGORIES: 'Messages/FETCH_CONVERT_TICKET_ALL_CATEGORIES',
    FETCH_CONVERT_TICKET_ALL_STATES: 'Messages/FETCH_CONVERT_TICKET_ALL_STATES',
    FETCH_CONVERT_TICKET_ALL_ASSIGNEE: 'Messages/FETCH_CONVERT_TICKET_ALL_ASSIGNEE',
    FETCH_CONVERT_TICKET_ALL_WATCHERS: 'Messages/FETCH_CONVERT_TICKET_ALL_WATCHERS',
    TOGGLE_PERSON_FOR_CONVERSATION: 'Messages/TOGGLE_PERSON_FOR_CONVERSATION',
    FETCH_SUGGESTED_STUFF_USERS: 'Messages/FETCH_SUGGESTED_STUFF_USERS',

    // User
    GET_LAST_VERSION: 'User/GET_LAST_VERSION',
    GET_AVAILABLE_UPDATE_URL: 'User/GET_AVAILABLE_UPDATE_URL',
    LOG_IN: 'User/LOG_IN',
    LOG_OUT: 'User/LOG_OUT',
    HANDLE_401: 'User/HANDLE_401',
    QUERY_PERSON_SUGGESTIONS: 'User/QUERY_PERSON_SUGGESTIONS',
    SET_AXIOS_AUTH_HEADERS: 'User/SET_AXIOS_AUTH_HEADERS',
    UPDATE_USER: 'User/UPDATE_USER',
    UPDATE_ADMIN: 'User/UPDATE_ADMIN',
    CLONE_CURRENT_USER: 'User/CLONE_CURRENT_USER',
    RESET_PASSWORD: 'User/RESET_PASSWORD',
    FETCH_ASSOCIATED_USERS: 'User/FETCH_ASSOCIATED_USERS',
    SAVE_PROFILE_IMAGE: 'User/SAVE_PROFILE_IMAGE',
    INITIALIZE_FIREBASE: 'User/INITIALIZE_FIREBASE',
    UPDATE_FIREBASE_TOKEN: 'User/UPDATE_FIREBASE_TOKEN',
    FETCH_MINIATURE: 'User/FETCH_MINIATURE',
    GET_FLOOR_PLAN: 'User/GET_FLOOR_PLAN',
    GET_ADMIN_FLOOR_PLAN: 'User/GET_ADMIN_FLOOR_PLAN',
    GET_USER_LANGUAGE_CODE: 'User/GET_USER_LANGUAGE_CODE',
    SET_LANGUAGE: 'User/SET_LANGUAGE',
    CHANGE_PASSWORD: 'User/CHANGE_PASSWORD',
    LOG_IN_USING_SAVED_CREDENTIALS: 'User/LOG_IN_USING_SAVED_CREDENTIALS',
    REFRESH_USER_DATA: 'User/REFRESH_USER_DATA',
    SET_PIN: 'User/SET_PIN',
    RESET_PIN: 'User/RESET_PIN',
    VALIDATE_PIN: 'User/VALIDATE_PIN',
    SEND_USER_INVITATION: 'User/SEND_USER_INVITATION',
    TRACK_ACTION: 'User/TRACK_ACTION',
    UPDATE_USER_LANGUAGE: 'User/UPDATE_USER_LANGUAGE',
    FETCH_STAFF_NOTIFICATIONS: 'User/FETCH_STAFF_NOTIFICATIONS',
    TOGGLE_STAFF_NOTIFICATIONS: 'User/TOGGLE_STAFF_NOTIFICATIONS',
    FETCH_DASHBOARD_ITEMS_PER_PAGE_COUNT: 'User/FETCH_DASHBOARD_ITEMS_PER_PAGE_COUNT',
    UPDATE_DASHBOARD_ITEMS_PER_PAGE_COUNT: 'User/UPDATE_DASHBOARD_ITEMS_PER_PAGE_COUNT',

    // Camera
    CANCEL_IMAGE_CAPTURE: 'Camera/CANCEL_IMAGE_CAPTURE',
    SHOW_CAMERA_DIALOG: 'Camera/SHOW_CAMERA_DIALOG',
    HIDE_CAMERA_DIALOG: 'Camera/HIDE_CAMERA_DIALOG',

    // Images
    FETCH_REMOTE_IMAGE_THUMBNAIL: 'Images/FETCH_REMOTE_IMAGE_THUMBNAIL',
    FETCH_REMOTE_IMAGE_LARGE: 'Images/FETCH_REMOTE_IMAGE_LARGE',
    FETCH_REMOTE_IMAGE_ORIGINAL: 'Images/FETCH_REMOTE_IMAGE_ORIGINAL',
    FETCH_DOCUMENT_PREVIEW: 'Images/FETCH_DOCUMENT_PREVIEW',
    FETCH_DOCUMENT_PDF: 'Images/FETCH_DOCUMENT_PDF',
    FETCH_USER_PROFILE_IMAGE: 'Images/FETCH_USER_PROFILE_IMAGE',

    // Viewport
    INITIALIZE_VIEWPORT: 'Viewport/INITIALIZE_VIEWPORT',
    SHOW_SHELF: 'Viewport/SHOW_SHELF',
    HIDE_SHELF: 'Viewport/HIDE_SHELF',
    SHOW_FORM: 'Viewport/SHOW_FORM',
    HIDE_FORM: 'Viewport/HIDE_FORM',

    // Notifications
    FETCH_NOTIFICATIONS: 'Notifications/FETCH_NOTIFICATIONS',
    FETCH_ADMIN_NOTIFICATIONS: 'Notifications/FETCH_ADMIN_NOTIFICATIONS',
    MARK_ACTIVE_NOTIFICATION_AS_SEEN: 'Notifications/MARK_ACTIVE_NOTIFICATION_AS_SEEN',
    POST_NOTIFICATIONS: 'Notifications/POST_NOTIFICATIONS',
    EDIT_NOTIFICATION: 'Notifications/EDIT_NOTIFICATION',
    DELETE_NOTIFICATION: 'Notifications/DELETE_NOTIFICATION',
    INITIATE_NOTIFICATION: 'Notifications/INITIATE_NOTIFICATION',
    FETCH_NOTIFICATION_MEDIA: 'Notifications/FETCH_NOTIFICATION_MEDIA',
    FETCH_NOTIFICATION_MEDIA_FOR_USER: 'Notifications/FETCH_NOTIFICATION_MEDIA_FOR_USER',

    // Attachments
    UPLOAD_ATTACHMENT: 'Attachments/UPLOAD_ATTACHMENT',

    // Recipients
    FETCH_TARGETED_RECIPIENTS: 'Recipients/FETCH_TARGETED_RECIPIENTS',

    // Options
    FETCH_OPTIONS: 'Options/FETCH_OPTIONS',
    POST_OPTION_IMAGE: 'Options/POST_OPTION_IMAGE',

    // Documents admin
    FETCH_ADMIN_DOCUMENTS: 'Documents/FETCH_ADMIN_DOCUMENTS',
    FETCH_CURRENT_DOCUMENT: 'Documents/FETCH_CURRENT_DOCUMENT',
    FETCH_PREVIEW_MEDIA: 'Documents/FETCH_PREVIEW_MEDIA',
    FETCH_DOCUMENT_MEDIA_PREVIEW: 'Documents/FETCH_DOCUMENT_MEDIA_PREVIEW',
    ADD_NEW_DOCUMENT: 'Documents/ADD_NEW_DOCUMENT',
    DELETE_DOCUMENT: 'Documents/DELETE_DOCUMENT',
    ADD_NEW_CONTRACT: 'Documents/ADD_NEW_CONTRACT',
    EDIT_DOCUMENT: 'Documents/EDIT_DOCUMENT',
    EDIT_CONTRACT: 'Documents/EDIT_CONTRACT',

    // Documents user
    FETCH_USER_DOCUMENTS: 'Documents/FETCH_USER_DOCUMENTS',
    FETCH_ACTIVE_DOCUMENT: 'Documents/FETCH_ACTIVE_DOCUMENT',
    SIGN_CONTRACT: 'Documents/SIGN_CONTRACT',
    MARK_ACTIVE_DOCUMENT_AS_SEEN: 'Documents/MARK_ACTIVE_DOCUMENT_AS_SEEN',

    // Localization
    FETCH_ALL_LANGUAGES: 'Localization/FETCH_ALL_LANGUAGES',
    FETCH_LANGUAGE_ALL_TEXTS: 'Localization/FETCH_LANGUAGE_ALL_TEXTS',
    SAVE_LANGUAGE_TEXT: 'Localization/SAVE_LANGUAGE_TEXT',
    ADD_NEW_LANGUAGE: 'Localization/ADD_NEW_LANGUAGE',
    ADD_LANGUAGE_NEW_KEY: 'Localization/ADD_LANGUAGE_NEW_KEY',
    IMPORT_LANGUAGE_CSV: 'Localization/IMPORT_LANGUAGE_CSV',
    GLOBAL_CHANGE_LANGUAGE: 'Localization/GLOBAL_CHANGE_LANGUAGE',
    FLAG_MISSING_TRANSLATION: 'Localization/FLAG_MISSING_TRANSLATION',
    SEND_MISSING_TRANSLATIONS: 'Localization/SEND_MISSING_TRANSLATIONS',

    // Feedback
    FETCH_FEEDBACK_EVENTS: 'Feedback/FETCH_FEEDBACK_EVENTS',
    SEND_FEEDBACK: 'Feedback/SEND_FEEDBACK',

    // Projects
    FETCH_PROJECTS: 'Projects/FETCH_PROJECTS',
    FETCH_PROJECT_CONFIGS: 'Projects/FETCH_PROJECT_CONFIGS',
    UPDATE_PROJECT_CONFIGS: 'Projects/UPDATE_PROJECT_CONFIGS',
    FETCH_PROJECT: 'Projects/FETCH_PROJECT',
    POST_PROJECTS: 'Projects/POST_PROJECTS',
    EDIT_PROJECT: 'Projects/EDIT_PROJECT',
    UPDATE_PROJECT_CONTACT: 'Projects/UPDATE_PROJECT_CONTACT',
    INITIATE_PROJECT: 'Projects/INITIATE_PROJECT',

    // Buildings
    FETCH_BUILDINGS: 'Buildings/FETCH_BUILDINGS',
    POST_BUILDINGS: 'Buildings/POST_BUILDINGS',
    EDIT_BUILDING: 'Buildings/EDIT_BUILDING',
    DELETE_BUILDING: 'Buildings/DELETE_BUILDING',
    QUERY_MANAGER_SUGGESTIONS: 'Buildings/QUERY_MANAGER_SUGGESTIONS',
    ADD_MANAGER_TO_BUILDING: 'Buildings/ADD_MANAGER_TO_BUILDING',
    ADD_STAFF_TO_BUILDING: 'Buildings/ADD_STAFF_TO_BUILDING',
    INITIATE_BUILDING: 'Buildings/INITIATE_BUILDING',

    // User management
    SEND_CONTACT_US: 'UserManagement/SEND_CONTACT_US',
    ADD_NEW_TENANT: 'UserManagement/ADD_NEW_TENANT',
    ADD_NEW_UPCOMING_TENANT: 'UserManagement/ADD_NEW_UPCOMING_TENANT',
    UPDATE_UPCOMING_TENANT: 'UserManagement/UPDATE_UPCOMING_TENANT',
    FETCH_UPCOMING_TENANT: 'UserManagement/FETCH_UPCOMING_TENANT',
    ADD_NEW_UPCOMING_GUEST: 'UserManagement/ADD_NEW_UPCOMING_GUEST',
    UPDATE_UPCOMING_GUEST: 'UserManagement/UPDATE_UPCOMING_GUEST',
    FETCH_UPCOMING_GUEST: 'UserManagement/FETCH_UPCOMING_GUEST',
    REVERT_UPCOMING_TENANT_TO_APPLICATION: 'UserManagement/REVERT_UPCOMING_TENANT_TO_APPLICATION',
    CANCEL_UPCOMING_TENANT_MOVE_IN: 'UserManagement/CANCEL_UPCOMING_TENANT_MOVE_IN',
    CANCEL_UPCOMING_GUEST_MOVE_IN: 'UserManagement/CANCEL_UPCOMING_GUEST_MOVE_IN',
    ADD_NEW_STAFF: 'UserManagement/ADD_NEW_STAFF',
    EDIT_TENANT_USER: 'UserManagement/EDIT_TENANT_USER',
    EDIT_STAFF_USER: 'UserManagement/EDIT_STAFF_USER',
    FETCH_USER_MANAGEMENT_ALL_STAFF_ROLES: 'UserManagement/FETCH_USER_MANAGEMENT_ALL_STAFF_ROLES',
    FETCH_MANAGEMENT_USERS: 'UserManagement/FETCH_MANAGEMENT_USERS',
    FETCH_TENANT_USERS: 'UserManagement/FETCH_TENANT_USERS',
    FETCH_CURRENT_TENANT_USER: 'UserManagement/FETCH_CURRENT_TENANT_USER',
    FETCH_CURRENT_STAFF_USER: 'UserManagement/FETCH_CURRENT_STAFF_USER',
    DELETE_MANAGEMENT_USER: 'UserManagement/DELETE_MANAGEMENT_USER',
    HARD_DELETE_MANAGEMENT_USER: 'UserManagement/HARD_DELETE_MANAGEMENT_USER',
    RESTORE_DELETED_MANAGEMENT_USER: 'UserManagement/RESTORE_DELETED_MANAGEMENT_USER',
    SAVE_PROFILING_CHANGES: 'UserManagement/SAVE_PROFILING_CHANGES',
    SAVE_PERSONAL_CHANGES: 'UserManagement/SAVE_PERSONAL_CHANGES',
    SAVE_APPLICATION_CHANGES: 'UserManagement/SAVE_APPLICATION_CHANGES',
    REASSIGN_TENANT_USER: 'UserManagement/REASSIGN_TENANT_USER',

    // Properties
    FETCH_PROPERTIES: 'Properties/FETCH_PROPERTIES',
    FETCH_COUNTRIES: 'Properties/FETCH_COUNTRIES',
    POST_PROPERTIES: 'Properties/POST_PROPERTIES',
    EDIT_PROPERTY: 'Properties/EDIT_PROPERTY',
    DELETE_PROPERTY: 'Properties/DELETE_PROPERTY',
    QUERY_PROPERTY_MANAGER_SUGGESTIONS: 'Properties/QUERY_PROPERTY_MANAGER_SUGGESTIONS',
    INITIATE_PROPERTY: 'Properties/INITIATE_PROPERTY',
    INITIALIZE_PROPERTY_SEARCH: 'Properties/INITIALIZE_PROPERTY_SEARCH',
    ADD_NEW_COMPANY: 'Properties/ADD_NEW_COMPANY',
    EDIT_PROPERTY_COMPANY: 'Properties/EDIT_PROPERTY_COMPANY',
    FETCH_CURRENT_PROPERTY: 'Properties/FETCH_CURRENT_PROPERTY',
    DELETE_TENANT_FROM_UNIT: 'Properties/DELETE_TENANT_FROM_UNIT',
    UPLOAD_PROPERTY_FLOOR_PLAN: 'Properties/UPLOAD_PROPERTY_FLOOR_PLAN',
    UPDATE_PROPERTY_DATES: 'Properties/UPDATE_PROPERTY_DATES',
    DELETE_UNIT: 'Properties/DELETE_UNIT',

    // Variants
    FETCH_VARIANTS: 'Variants/FETCH_VARIANTS',
    FETCH_VARIANT_PREVIEW_MEDIA: 'Variants/FETCH_VARIANT_PREVIEW_MEDIA',
    FETCH_VARIANT_MEDIA: 'Variants/FETCH_VARIANT_MEDIA',
    POST_VARIANTS: 'Variants/POST_VARIANTS',
    EDIT_VARIANT: 'Variants/EDIT_VARIANT',
    DELETE_VARIANT: 'Variants/DELETE_VARIANT',
    INITIATE_VARIANT: 'Variants/INITIATE_VARIANT',
    UPLOAD_FLOOR_PLAN: 'Variants/UPLOAD_FLOOR_PLAN',
    DELETE_UNIT_TYPE: 'Variants/DELETE_UNIT_TYPE',

    // Events
    FETCH_EVENT: 'Events/FETCH_EVENT',
    FETCH_EVENTS: 'Events/FETCH_EVENTS',
    FETCH_EVENT_ADMIN: 'Events/FETCH_EVENT_ADMIN',
    FETCH_ADMIN_EVENTS: 'Events/FETCH_ADMIN_EVENTS',
    POST_EVENTS: 'Events/POST_EVENTS',
    POST_POSTS: 'Events/POST_POSTS',
    EDIT_EVENT: 'Events/EDIT_EVENT',
    EDIT_POST: 'Events/EDIT_POST',
    DELETE_EVENT: 'Events/DELETE_EVENT',
    DELETE_POST: 'Events/DELETE_POST',
    INITIATE_EVENT: 'Events/INITIATE_EVENT',
    SYNCHRONIZE_EVENTS_WITH_CALENDAR: 'Events/SYNCHRONIZE_EVENTS_WITH_CALENDAR',
    HIDE_EDIT_EVENT_FORM: 'Events/HIDE_EDIT_EVENT_FORM',
    POST_USER_ATTENDING_CALENDAR_EVENT: 'Events/POST_USER_ATTENDING_CALENDAR_EVENT',
    FETCH_EVENT_MEDIA: 'Events/FETCH_EVENT_MEDIA',
    FETCH_EVENT_ATTENDEES: 'Events/FETCH_EVENT_ATTENDEES',

    // Corporations
    FETCH_CORPORATIONS: 'Corporations/FETCH_CORPORATIONS',
    FETCH_ADMIN_CURRENT_CORPORATION: 'Corporations/FETCH_ADMIN_CURRENT_CORPORATION',
    UPDATE_CORPORATION_CONFIGS: 'Corporations/UPDATE_CORPORATION_CONFIGS',

    // Corporation links
    FETCH_USER_CORPORATION_LINKS: 'CorporationLinks/FETCH_USER_CORPORATION_LINKS',

    // Tickets
    FETCH_ALL_TICKETS: 'Tickets/FETCH_ALL_TICKETS',
    RESET_ACTIVE_TICKET_ROWS: 'Tickets/RESET_ACTIVE_TICKET_ROWS',
    FETCH_CURRENT_TICKET: 'Tickets/FETCH_CURRENT_TICKET',
    EDIT_CURRENT_TICKET: 'Tickets/EDIT_CURRENT_TICKET',
    SEND_MESSAGE_TO_TICKET_USER: 'Tickets/SEND_MESSAGE_TO_TICKET_USER',
    DELETE_TICKET_MESSAGE: 'Tickets/DELETE_TICKET_MESSAGE',
    FETCH_TICKET_CONVERSATION: 'Tickets/FETCH_TICKET_CONVERSATION',
    FETCH_TICKET_ALL_STATES: 'Tickets/FETCH_TICKET_ALL_STATES',
    FETCH_TICKET_ROLE_ASSIGNEE: 'Tickets/FETCH_TICKET_ROLE_ASSIGNEE',
    FETCH_TICKET_SUGGESTED_WATCHERS: 'Tickets/FETCH_TICKET_SUGGESTED_WATCHERS',
    OPEN_TICKET_MODAL: 'Tickets/OPEN_TICKET_MODAL',
    FETCH_ADD_TICKET_PROPERTIES: 'Tickets/FETCH_ADD_TICKET_PROPERTIES',
    FETCH_ADD_TICKET_RECIEVERS: 'Tickets/FETCH_ADD_TICKET_RECIEVERS',
    ADMIN_ADD_TICKET: 'Tickets/ADMIN_ADD_TICKET',
    INITIALIZE_TICKET_SOCKET: 'Tickets/INITIALIZE_TICKET_SOCKET',

    // Ticket Attributes
    FETCH_TICKET_ALL_TYPES: 'TicketAttributes/FETCH_TICKET_ALL_TYPES',
    FETCH_TICKET_ALL_CATEGORIES: 'TicketAttributes/FETCH_TICKET_ALL_CATEGORIES',
    FETCH_TICKET_INQUIRIES: 'TicketAttributes/FETCH_TICKET_INQUIRIES',
    FETCH_CURRENT_EDIT_CATEGORY: 'TicketAttributes/FETCH_CURRENT_EDIT_CATEGORY',
    FETCH_CURRENT_EDIT_INQUIRY: 'TicketAttributes/FETCH_CURRENT_EDIT_INQUIRY',
    ADD_NEW_INQUIRY_CATEGORY: 'TicketAttributes/ADD_NEW_INQUIRY_CATEGORY',
    EDIT_INQUIRY_CATEGORY: 'TicketAttributes/EDIT_INQUIRY_CATEGORY',
    DELETE_INQUIRY_CATEGORY: 'TicketAttributes/DELETE_INQUIRY_CATEGORY',
    DELETE_INQUIRY: 'TicketAttributes/DELETE_INQUIRY',
    ADD_NEW_INQUIRY: 'TicketAttributes/ADD_NEW_INQUIRY',
    EDIT_INQUIRY: 'TicketAttributes/EDIT_INQUIRY',
    FETCH_INQUIRY_ROLE_ASSIGNEE: 'TicketAttributes/FETCH_INQUIRY_ROLE_ASSIGNEE',
    FETCH_INQUIRY_ROLE_ASSIGNEE_USERS: 'TicketAttributes/FETCH_INQUIRY_ROLE_ASSIGNEE_USERS',
    UPDATE_INQUIRY_SORT: 'TicketAttributes/UPDATE_INQUIRY_SORT',
    UPDATE_INQUIRY_TYPE_SORT: 'TicketAttributes/UPDATE_INQUIRY_TYPE_SORT',
    UPDATE_INQUIRY_CATEGORY_SORT: 'TicketAttributes/UPDATE_INQUIRY_CATEGORY_SORT',

    // Waiting Lists
    FETCH_ALL_WAITING_LISTS: 'WaitingLists/FETCH_ALL_WAITING_LISTS',
    TOGGLE_WAITING_LIST_TAB: 'WaitingLists/TOGGLE_WAITING_LIST_TAB',
    FETCH_CURRENT_PREVIEWED_APPLICATION: 'WaitingLists/FETCH_CURRENT_PREVIEWED_APPLICATION',
    FETCH_ALL_AVAILABLE_APARTMENTS: 'WaitingLists/FETCH_ALL_AVAILABLE_APARTMENTS',
    RESET_ACTIVE_APPLICATION_ROWS: 'WaitingLists/RESET_ACTIVE_APPLICATION_ROWS',
    RESET_ACTIVE_APARTMENT_ROWS: 'WaitingLists/RESET_ACTIVE_APARTMENT_ROWS',
    RESET_PREVIEW_ALL_ACTIONS: 'WaitingLists/RESET_PREVIEW_ALL_ACTIONS',
    FETCH_PREVIEWED_DOCUMENT: 'WaitingLists/FETCH_PREVIEWED_DOCUMENT',
    DIRECTLY_DOWNLOAD_PREVIEWED_DOCUMENT: 'WaitingLists/DIRECTLY_DOWNLOAD_PREVIEWED_DOCUMENT',
    ACCEPT_APPLICATION: 'WaitingLists/ACCEPT_APPLICATION',
    ASSIGN_UNIT: 'WaitingLists/ASSIGN_UNIT',
    DECLINE_APPLICATION: 'WaitingLists/DECLINE_APPLICATION',
    TOGGLE_APPLICATION_ACTIVE: 'WaitingLists/TOGGLE_APPLICATION_ACTIVE',
    DELETE_APPLICATION: 'WaitingLists/DELETE_APPLICATION',
    FETCH_OAUTH_CLIENT_DATA: 'WaitingLists/FETCH_OAUTH_CLIENT_DATA',
    SEND_EXPIRATION_EMAIL: 'WaitingLists/SEND_EXPIRATION_EMAIL',
    FETCH_CURRENT_APPLICATION_MASTER_DATA: 'WaitingLists/FETCH_CURRENT_APPLICATION_MASTER_DATA',
    UPDATE_APPLICATION: 'WaitingLists/UPDATE_APPLICATION',

    // Presentation Flow
    TOGGLE_PRESENTATION_FLOW_TAB: 'PresentationFlows/TOGGLE_PRESENTATION_FLOW_TAB',
    FETCH_ALL_VACANT_UNITS: 'PresentationFlows/FETCH_ALL_VACANT_UNITS',
    FETCH_CURRENT_VACANT_UNIT: 'PresentationFlows/FETCH_CURRENT_VACANT_UNIT',
    FETCH_ALL_INPROGRESS_OFFERS: 'PresentationFlows/FETCH_ALL_INPROGRESS_OFFERS',
    FETCH_APPLICATIONS_FOR_PRESENTATION: 'PresentationFlows/FETCH_APPLICATIONS_FOR_PRESENTATION',
    SEND_PRESENTATION_OFFER: 'PresentationFlows/SEND_PRESENTATION_OFFER',
    FETCH_CURRENT_EDIT_PRESENTATION: 'PresentationFlows/FETCH_CURRENT_EDIT_PRESENTATION',
    SEND_PRESENTATION_EDIT_OFFER: 'PresentationFlows/SEND_PRESENTATION_EDIT_OFFER',
    SORT_ICON_TOGGLE: 'PresentationFlows/SORT_ICON_TOGGLE',
    FETCH_ALL_DEADLINE_OFFERS: 'PresentationFlows/FETCH_ALL_DEADLINE_OFFERS',
    ASSIGN_TENANT: 'PresentationFlows/ASSIGN_TENANT',
    FETCH_ALL_SENT_OFFERS: 'PresentationFlows/FETCH_ALL_SENT_OFFERS',
    RE_OPEN_OFFER: 'PresentationFlows/RE_OPEN_OFFER',
    COMPLETE_OFFER: 'PresentationFlows/COMPLETE_OFFER',
    CLOSE_OFFER: 'PresentationFlows/CLOSE_OFFER',
    FETCH_ALL_COMPLETED_OFFERS: 'PresentationFlows/FETCH_ALL_COMPLETED_OFFERS',
    PRESENTATION_DEADLINE_REACHED: 'PresentationFlows/PRESENTATION_DEADLINE_REACHED',
    FETCH_ALL_CLOSED_OFFERS: 'PresentationFlows/FETCH_ALL_CLOSED_OFFERS',

    // User Tickets
    FETCH_ALL_USER_TICKETS: 'UserTickets/FETCH_ALL_USER_TICKETS',
    FETCH_USER_TICKET_ALL_TYPES: 'UserTickets/FETCH_USER_TICKET_ALL_TYPES',
    FETCH_USER_CURRENT_TICKET_TYPE: 'UserTickets/FETCH_USER_CURRENT_TICKET_TYPE',
    FETCH_USER_TICKET_ALL_CATEGORIES: 'UserTickets/FETCH_USER_TICKET_ALL_CATEGORIES',
    FETCH_USER_CURRENT_TICKET_CATEGORY: 'UserTickets/FETCH_USER_CURRENT_TICKET_CATEGORY',
    FETCH_USER_CURRENT_TICKET_INQUIRY: 'UserTickets/FETCH_USER_CURRENT_TICKET_INQUIRY',
    FETCH_USER_TICKET_ALL_INQUIRIES: 'UserTickets/FETCH_USER_TICKET_ALL_INQUIRIES',
    FETCH_USER_CURRENT_TICKET: 'UserTickets/FETCH_USER_CURRENT_TICKET',
    FETCH_USER_TICKET_CONVERSATION: 'UserTickets/FETCH_USER_TICKET_CONVERSATION',
    SEND_TICKET_MESSAGE_TO_ADMIN: 'UserTickets/SEND_TICKET_MESSAGE_TO_ADMIN',
    USER_ADD_NEW_TICKET: 'UserTickets/USER_ADD_NEW_TICKET',
    REMOVE_TICKET_IMAGE: 'UserTickets/REMOVE_TICKET_IMAGE',
    USER_CANCEL_TICKET: 'UserTickets/USER_CANCEL_TICKET',
    CHANGE_TICKET_STATE: 'UserTickets/CHANGE_TICKET_STATE',
    CHANGE_TICKET_ASSIGNEE: 'UserTickets/CHANGE_TICKET_ASSIGNEE',
    INITIALIZE_USER_TICKET_SOCKET: 'UserTickets/INITIALIZE_USER_TICKET_SOCKET',
    CHANGE_TICKET_PRIORITY: 'UserTickets/CHANGE_TICKET_PRIORITY',
    FETCH_TICKET_IMAGES: 'UserTickets/FETCH_TICKET_IMAGES',
    USER_TICKET_RESPONDED: 'UserTickets/USER_TICKET_RESPONDED',

    // Staff Properties
    FETCH_ALL_STAFF_PROPERTIES: 'StaffProperties/FETCH_ALL_STAFF_PROPERTIES',
    FETCH_STAFF_PROPERTY: 'StaffProperties/FETCH_STAFF_PROPERTY',

    // Integrations
    FETCH_INTEGRATION_ALL_CORPORATIONS: 'Integrations/FETCH_INTEGRATION_ALL_CORPORATIONS',
    FETCH_ALL_INTEGRATIONS: 'Integrations/FETCH_ALL_INTEGRATIONS',
    FETCH_CURRENT_INTEGRATION_DATA: 'Integrations/FETCH_CURRENT_INTEGRATION_DATA',
    UPLOAD_INTEGRATION_DATA: 'Integrations/UPLOAD_INTEGRATION_DATA',
    RESET_ACTIVE_INTEGRATION_SORTS: 'Integrations/RESET_ACTIVE_INTEGRATION_SORTS',
    FETCH_INTEGRATION_TYPES: 'Integrations/FETCH_INTEGRATION_TYPES',
    QUEUE_INTEGRATION_DATA_IMPORT: 'Integrations/QUEUE_INTEGRATION_DATA_IMPORT',
    INITIALIZE_INTEGRATIONS_SOCKET: 'Integrations/INITIALIZE_INTEGRATIONS_SOCKET',

    // User profile
    FETCH_ALL_USER_PROFILES: 'UserProfiles/FETCH_ALL_USER_PROFILES',
    FETCH_CURRENT_USER_PROFILE: 'UserProfiles/FETCH_CURRENT_USER_PROFILE',

    // Event logs
    FETCH_EVENT_LOGS: 'EventLogs/FETCH_EVENT_LOGS',
    FETCH_EVENT_LOGS_UNSEEN: 'EventLogs/FETCH_EVENT_LOGS_UNSEEN',
    FETCH_EVENT_LOGS_UNSEEN_COUNT: 'EventLogs/FETCH_EVENT_LOGS_UNSEEN_COUNT',
    MAKE_EVENT_LOG_SEEN: 'EventLogs/MAKE_EVENT_LOG_SEEN',
    SET_EVENT_LOGS_SEARCH_OPTION: 'EventLogs/SET_EVENT_LOGS_SEARCH_OPTION',
    MARK_ALL_EVENT_LOGS_AS_SEEN: 'EventLogs/MARK_ALL_EVENT_LOGS_AS_SEEN',
    INITIALIZE_EVENT_LOG_SOCKET: 'EventLogs/INITIALIZE_EVENT_LOG_SOCKET',

    // Shared Facilities
    CANCEL_RESERVATION: 'SharedFacilities/CANCEL_RESERVATION',
    FETCH_PROJECT_ALL_FACILITIES: 'SharedFacilities/FETCH_PROJECT_ALL_FACILITIES',
    FETCH_ACTIVE_ADMIN_FACILITY_PHOTOS: 'SharedFacilities/FETCH_ACTIVE_ADMIN_FACILITY_PHOTOS',
    FETCH_ACTIVE_ADMIN_FACILITY_BOOKINGS: 'SharedFacilities/FETCH_ACTIVE_ADMIN_FACILITY_BOOKINGS',
    FETCH_USER_SHARED_FACILITIES: 'SharedFacilities/FETCH_USER_SHARED_FACILITIES',
    FETCH_SHARED_FACILITIES_PHOTOS: 'SharedFacilities/FETCH_SHARED_FACILITIES_PHOTOS',
    FETCH_USER_FACILITIES_BOOKINGS: 'SharedFacilities/FETCH_USER_FACILITIES_BOOKINGS',
    CANCEL_USER_BOOKING: 'SharedFacilities/CANCEL_USER_BOOKING',
    ADD_USER_BOOKING: 'SharedFacilities/ADD_USER_BOOKING',
    DELETE_ADMIN_ACTIVE_FACILITY: 'SharedFacilities/DELETE_ADMIN_ACTIVE_FACILITY',
    FETCH_ALL_FACILITY_TYPES: 'SharedFacilities/FETCH_ALL_FACILITY_TYPES',
    ADD_NEW_FACILITY: 'SharedFacilities/ADD_NEW_FACILITY',
    ADD_PHOTOS_TO_NEW_FACILITY: 'SharedFacilities/ADD_PHOTOS_TO_NEW_FACILITY',
    FETCH_FACILITY_UNAVAILABILITY: 'SharedFacilities/FETCH_FACILITY_UNAVAILABILITY',
    FETCH_FACILITY_FOR_UPDATE: 'SharedFacilities/FETCH_FACILITY_FOR_UPDATE',
    UPDATE_FACILITY: 'SharedFacilities/UPDATE_FACILITY',
    FETCH_FACILITY_PHOTOS_FOR_UPDATE: 'SharedFacilities/FETCH_FACILITY_PHOTOS_FOR_UPDATE',
    UPDATE_FACILITY_PHOTOS: 'SharedFacilities/UPDATE_FACILITY_PHOTOS',
    UPDATE_FACILITY_PHOTOS_ORDER: 'SharedFacilities/UPDATE_FACILITY_PHOTOS_ORDER',
    CHANGE_ACTIVE_ADMIN_FACILITY_AVAILABLE: 'SharedFacilities/CHANGE_ACTIVE_ADMIN_FACILITY_AVAILABLE',
    FETCH_FACILITY_WATCHERS: 'SharedFacilities/FETCH_FACILITY_WATCHERS',
    FETCH_FACILITY_ALL_WATCHERS: 'SharedFacilities/FETCH_FACILITY_ALL_WATCHERS',

    // Tags
    FETCH_TAGS: 'Tags/FETCH_TAGS',
    CREATE_SOCIAL_TAG: 'Tags/CREATE_SOCIAL_TAG',
    CREATE_EDUCATIONAL_TAG: 'Tags/CREATE_EDUCATIONAL_TAG',

    // Categories
    FETCH_DOCUMENT_CATEGORIES: 'Categories/FETCH_DOCUMENT_CATEGORIES',

    // Roles and permissions
    FETCH_PERMISSION_ROLES: 'RolesAndPermissions/FETCH_PERMISSION_ROLES',
    FETCH_PERMISSION_FEATURES: 'RolesAndPermissions/FETCH_PERMISSION_FEATURES',
    TOGGLE_PERMISSION_ROLE_FEATURE: 'RolesAndPermissions/TOGGLE_PERMISSION_ROLE_FEATURE',
    ADD_NEW_ROLE: 'RolesAndPermissions/ADD_NEW_ROLE',
    EDIT_CURRENT_ROLE: 'RolesAndPermissions/EDIT_CURRENT_ROLE',

    // Unit Finance
    FETCH_CREDITS_FINANCE_DATA: 'UnitFinance/FETCH_CREDITS_FINANCE_DATA',
    FETCH_UNIT_ORDER_LINES: 'UnitFinance/FETCH_UNIT_ORDER_LINES',
    FETCH_UNIT_BALANCE_ACCOUNT_DATA: 'UnitFinance/FETCH_UNIT_BALANCE_ACCOUNT_DATA',
    FETCH_PERIODICAL_CHARGES_FINANCE_DATA: 'UnitFinance/FETCH_PERIODICAL_CHARGES_FINANCE_DATA',
    FETCH_ONE_TIME_CHARGES_FINANCE_DATA: 'UnitFinance/FETCH_ONE_TIME_CHARGES_FINANCE_DATA',
    FETCH_REFUNDS_FINANCE_DATA: 'UnitFinance/FETCH_REFUNDS_FINANCE_DATA',
    FETCH_FIXED_CHARGES_FINANCE_DATA: 'UnitFinance/FETCH_FIXED_CHARGES_FINANCE_DATA',
    FETCH_CONSUMPTION_ACCOUNTS_FINANCE_DATA: 'UnitFinance/FETCH_CONSUMPTION_ACCOUNTS_FINANCE_DATA',
    ADD_FIXED_CHARGE: 'UnitFinance/ADD_FIXED_CHARGE',
    ADD_REFUND_CHARGE: 'UnitFinance/ADD_REFUND_CHARGE',
    ADD_PERIODICAL_CHARGE: 'UnitFinance/ADD_PERIODICAL_CHARGE',
    ADD_ONE_TIME_CHARGE: 'UnitFinance/ADD_ONE_TIME_CHARGE',
    REMOVE_PERIODICAL_CHARGE: 'UnitFinance/REMOVE_PERIODICAL_CHARGE',
    ADD_CONSUMPTION_ACCOUNT: 'UnitFinance/ADD_CONSUMPTION_ACCOUNT',
    PAUSE_PERIODICAL_CHARGE: 'UnitFinance/PAUSE_PERIODICAL_CHARGE',
    START_PERIODICAL_CHARGE: 'UnitFinance/START_PERIODICAL_CHARGE',
    UPDATE_PERIODICAL_CHARGE: 'UnitFinance/UPDATE_PERIODICAL_CHARGE',
    FETCH_INTERVALS: 'UnitFinance/FETCH_INTERVALS',
    FETCH_PAYMENT_ORDER_LINE_TYPES: 'UnitFinance/FETCH_PAYMENT_ORDER_LINE_TYPES',
    FETCH_UNIT_ARREARS: 'UnitFinance/FETCH_UNIT_ARREARS',
    SAVE_NEW_DEPOSIT: 'CreateDepositForm/SAVE_NEW_DEPOSIT',
    SAVE_NEW_REFUND: 'CreateRefundForm/SAVE_NEW_REFUND',
    FETCH_CURRENCIES: 'UnitFinance/FETCH_CURRENCIES',
    FETCH_PAYMENT_PROVIDERS: 'UnitFinance/FETCH_PAYMENT_PROVIDERS',
    FETCH_UNIT_ORDERS: 'UnitFinance/FETCH_UNIT_ORDERS',
    FETCH_UNIT_REFUNDABLE_ORDERS: 'UnitFinance/FETCH_UNIT_REFUNDABLE_ORDERS',
    TOGGLE_CREATE_DEPOSIT_POPUP_VISIBILITY: 'CreateDepositForm/TOGGLE_CREATE_DEPOSIT_POPUP_VISIBILITY',
    TOGGLE_CREATE_REFUND_POPUP_VISIBILITY: 'CreateRefundForm/TOGGLE_CREATE_REFUND_POPUP_VISIBILITY',

    // Unpaid Payments
    FETCH_UNPAID_PAYMENTS_DATA: 'UnpaidPayments/FETCH_UNPAID_PAYMENTS_DATA',
    FETCH_CORPORATION_TRANSACTIONS_DATA: 'CorpTransactions/FETCH_CORPORATION_TRANSACTIONS_DATA',

    // Credit Cards
    FETCH_USER_CREDIT_CARDS: 'CreditCards/FETCH_USER_CREDIT_CARDS',
    ADD_USER_CREDIT_CARDS: 'CreditCards/ADD_USER_CREDIT_CARDS',
    DELETE_USER_CREDIT_CARDS: 'CreditCards/DELETE_USER_CREDIT_CARDS',
    MAKE_PAYMENT_METHOD_DEFAULT: 'CreditCards/MAKE_PAYMENT_METHOD_DEFAULT',
    GET_USER_DEFAULT_PAYMENT_METHOD: 'CreditCards/GET_USER_DEFAULT_PAYMENT_METHOD',
    DELETE_DEFAULT_PAYMENT_METHOD: 'CreditCards/DELETE_DEFAULT_PAYMENT_METHOD',

    // User Transactions
    FETCH_USER_TRANSACTIONS: 'UserWallet/FETCH_USER_TRANSACTIONS',
    FETCH_TRANSACTION: 'UserWallet/FETCH_TRANSACTION',
    FETCH_UPCOMING_PAYMENTS_DATA: 'UserUpcomingPayments/FETCH_UPCOMING_PAYMENTS_DATA',
    FETCH_ORDER_DETAILS: 'UserUpcomingPayments/FETCH_ORDER_DETAILS',
    PAY_FOR_ORDER: 'UserUpcomingPayments/PAY_FOR_ORDER',
    USER_TRANSACTION_CANCEL: 'UserUpcomingPayments/USER_TRANSACTION_CANCEL',
    FETCH_STRIPE_PUBLIC_KEY: 'UserUpcomingPayments/FETCH_STRIPE_PUBLIC_KEY',

    // CORPORATION FINANCES
    CONNECT_STRIPE_ACCOUNT_TO_CORPORATION: 'FinanceControl/CONNECT_STRIPE_ACCOUNT_TO_CORPORATION',
    DISCONNECT_STRIPE_ACCOUNT_TO_CORPORATION: 'FinanceControl/DISCONNECT_STRIPE_ACCOUNT_TO_CORPORATION',
    CHECK_CORPORATION_STRIPE_CONNECTION_STATUS: 'FinanceControl/CHECK_CORPORATION_STRIPE_CONNECTION_STATUS',

    // Property notes
    FETCH_PROPERTY_NOTES: 'PropertyNotes/FETCH_PROPERTY_NOTES',
    FETCH_NOTE_DETAILS: 'PropertyNotes/FETCH_NOTE_DETAILS',
    ADD_NEW_NOTE: 'PropertyNotes/ADD_NEW_NOTE',
    EDIT_PROPERTY_NOTE: 'PropertyNotes/EDIT_PROPERTY_NOTE',
    DELETE_UNIT_NOTE: 'PropertyNotes/DELETE_UNIT_NOTE',
    FETCH_NOTE_PREVIEW_MEDIA: 'PropertyNotes/FETCH_NOTE_PREVIEW_MEDIA',

    // Likes
    ADD_LIKE: 'Likes/ADD_LIKE',
    REMOVE_LIKE: 'Likes/REMOVE_LIKE',

    // Grouping
    FETCH_ALL_GROUPINGS: 'Groupings/FETCH_ALL_GROUPINGS',
    FETCH_CURRENT_GROUPING: 'Groupings/FETCH_CURRENT_GROUPING',
    FETCH_GROUPING_TYPES: 'Groupings/FETCH_GROUPING_TYPES',
    ADD_NEW_GROUPING: 'Groupings/ADD_NEW_GROUPING',
    EDIT_GROUPING: 'Groupings/EDIT_GROUPING',
    DELETE_GROUPING: 'Groupings/DELETE_GROUPING',
    FETCH_UNIT_GROUPINGS: 'Groupings/FETCH_UNIT_GROUPINGS',
    FETCH_GROUPING_RESIDENTS: 'Groupings/FETCH_GROUPING_RESIDENTS',
    REMOVE_UNIT_FROM_GROUPING: 'Groupings/REMOVE_UNIT_FROM_GROUPING',

    // Table Config
    SAVE_SELECTED_TABLE_VIEW: 'TableConfigs/SAVE_SELECTED_TABLE_VIEW',
    DELETE_TABLE_VIEW: 'TableConfigs/DELETE_TABLE_VIEW',
    UPDATE_TABLE_VIEW_DEFAULT_VALUE: 'TableConfigs/UPDATE_TABLE_VIEW_DEFAULT_VALUE',
    CREATE_NEW_VIEW: 'TableConfigs/CREATE_NEW_VIEW',
    INITIALIZE_TABLE_CONFIG: 'TableConfigs/INITIALIZE_TABLE_CONFIG',

    // Unit Grouping Charts
    FETCH_UNIT_GROUPING_TENANTS_DEMOGRAPHIC: 'UnitGroupingCharts/FETCH_UNIT_GROUPING_TENANTS_DEMOGRAPHIC',

    // Template Renderer
    FETCH_TEMPLATE_RENDERER: 'TemplateRenderer/FETCH_TEMPLATE_RENDERER',

    // User Tickets Attributes
    FETCH_INQUIRY_TYPES: 'UserTicketsAttributes/FETCH_INQUIRY_TYPES',
    FETCH_INQUIRY_CATEGORIES: 'UserTicketsAttributes/FETCH_INQUIRY_CATEGORIES',
    FETCH_INQUIRIES: 'UserTicketsAttributes/FETCH_INQUIRIES',
    FETCH_INQUIRY_ANSWER: 'UserTicketsAttributes/FETCH_INQUIRY_ANSWER',

    // File Upload
    UPLOAD_FILE: 'FileUpload/UPLOAD_FILE',

    // Comments
    FETCH_NOTIFICATION_COMMENTS: 'Comments/FETCH_NOTIFICATION_COMMENTS',
    ADD_COMMENT: 'Comments/ADD_COMMENT',
    REMOVE_COMMENT: 'Comments/REMOVE_COMMENT',
    INITIALIZE_COMMENTS_SOCKET: 'Comments/INITIALIZE_COMMENTS_SOCKET',
    MARK_COMMENT_AS_SEEN: 'Comments/MARK_COMMENT_AS_SEEN',
    CLOSE_COMMENTS_SOCKET: 'Comments/CLOSE_COMMENTS_SOCKET',

    // Identities
    FETCH_IDENTITIES: 'Identities/FETCH_IDENTITIES',
    FETCH_IDENTITIES_NOTIFICATIONS: 'Identities/FETCH_IDENTITIES_NOTIFICATIONS',
    SELECT_IDENTITY: 'Identities/SELECT_IDENTITY',
    SWITCH_IDENTITY: 'Identities/SWITCH_IDENTITY',
    SET_IDENTITY: 'Identities/SET_IDENTITY',
    INIT_IDENTITIES_SOCKET: 'Identities/INIT_IDENTITIES_SOCKET',
    ACCEPT_EULA: 'Identities/ACCEPT_EULA',

    // Global overlay
    SUBMIT_GLOBAL_OVERLAY_VISIBILITY: 'GlobalOverlay/SUBMIT_GLOBAL_OVERLAY_VISIBILITY',
    SUBMIT_GLOBAL_OVERLAY_CONFIG: 'GlobalOverlay/SUBMIT_GLOBAL_OVERLAY_CONFIG',

    // Abuse
    REPORT_CONTENT: 'Abuse/REPORT_CONTENT',
    BLOCK_CONTENT: 'Abuse/BLOCK_CONTENT',
    UNBLOCK_CONTENT: 'Abuse/UNBLOCK_CONTENT',
    HIDE_CONTENT: 'Abuse/HIDE_CONTENT',
    UNHIDE_CONTENT: 'Abuse/UNHIDE_CONTENT',
};

export const Mutations = {
    // Attachments
    RESET_ATTACHMENTS_STORE_STATE: 'Attachments/RESET_ATTACHMENTS_STORE_STATE',

    // Dashboard:
    SET_DASHBOARD_NOTIFICATIONS: 'TenantNotifications/SET_DASHBOARD_NOTIFICATIONS',
    SET_NOTIFICATIONS_LOGS: 'TenantNotifications/SET_NOTIFICATIONS_LOGS',
    ADD_NOTIFICATIONS_LOG: 'TenantNotifications/ADD_NOTIFICATIONS_LOG',
    SET_TENANT_UPCOMING_EVENTS: 'TenantNotifications/SET_TENANT_UPCOMING_EVENTS',
    SET_TENANT_UNREAD_NOTIFICATIONS_COUNT: 'TenantNotifications/SET_TENANT_UNREAD_NOTIFICATIONS_COUNT',
    RESET_DASHBOARD_NOTIFICATIONS: 'TenantNotifications/RESET_DASHBOARD_NOTIFICATIONS',
    RESET_NOTIFICATIONS_LOGS: 'TenantNotifications/RESET_NOTIFICATIONS_LOGS',
    SET_DASHBOARD_PAGE: 'TenantNotifications/SET_DASHBOARD_PAGE',
    SET_TENANT_LOGS_PAGE: 'TenantNotifications/SET_TENANT_LOGS_PAGE',
    SET_LAST_DASHBOARD_PAGE: 'TenantNotifications/SET_LAST_DASHBOARD_PAGE',
    SET_LAST_TENANT_LOGS_PAGE: 'TenantNotifications/SET_LAST_TENANT_LOGS_PAGE',
    SET_DASHBOARD_PAGE_ACTIVE_FILTER: 'TenantNotifications/SET_DASHBOARD_PAGE_ACTIVE_FILTER',
    ADD_NOTIFICATION_LIKE: 'TenantNotifications/ADD_NOTIFICATION_LIKE',
    REMOVE_NOTIFICATION_LIKE: 'TenantNotifications/REMOVE_NOTIFICATION_LIKE',
    CHANGE_UPCOMING_EVENT_ATTENDING_STATUS: 'TenantNotifications/CHANGE_UPCOMING_EVENT_ATTENDING_STATUS',
    CHANGE_NOTIFICATION_SEEN_STATUS: 'TenantNotifications/CHANGE_NOTIFICATION_SEEN_STATUS',
    CHANGE_NOTIFICATIONS_SEEN_STATUS: 'TenantNotifications/CHANGE_NOTIFICATIONS_SEEN_STATUS',
    SET_TENANT_ACTIVE_NOTIFICATION: 'TenantNotifications/SET_TENANT_ACTIVE_NOTIFICATION',
    RESET_DASHBOARD_STORE_STATE: 'TenantNotifications/RESET_DASHBOARD_STORE_STATE',

    // Messages
    ADD_CONVERSATION: 'Messages/ADD_CONVERSATION',
    ADD_CONVERSATION_MESSAGE: 'Messages/ADD_CONVERSATION_MESSAGE',
    ADD_CONVERSATION_MESSAGES: 'Messages/ADD_CONVERSATION_MESSAGES',
    CREATE_MESSAGE: 'Messages/CREATE_MESSAGE',
    UPDATE_CURRENT_MESSAGE: 'Messages/UPDATE_CURRENT_MESSAGE',
    UPDATE_ACTIVE_CONVERSATION: 'Messages/UPDATE_ACTIVE_CONVERSATION',
    MARK_CONVERSATIONS_AS_LOADED: 'Messages/MARK_CONVERSATIONS_AS_LOADED',
    MARK_CONVERSATION_AS_SEEN: 'Messages/MARK_CONVERSATION_AS_SEEN',
    SHOW_PERSON_SUGGESTIONS: 'Messages/SHOW_PERSON_SUGGESTIONS',
    SET_MESSAGES_VIEW_MODE: 'Messages/SET_MESSAGES_VIEW_MODE',
    UPDATE_CONVERSATION_SEARCH_TERM: 'Messages/UPDATE_CONVERSATION_SEARCH_TERM',
    SET_ADD_CONVERSATION_DIALOG_VISIBILITY: 'Messages/SET_ADD_CONVERSATION_DIALOG_VISIBILITY',
    SET_VISIBLE_CONVERSATIONS_STATUS: 'Messages/SET_VISIBLE_CONVERSATIONS_STATUS',
    SET_CONVERSATION_STATUS: 'Messages/SET_CONVERSATION_STATUS',
    SET_ACTIVE_OPEN_CONVERSATIONS: 'Messages/SET_ACTIVE_OPEN_CONVERSATIONS',
    SET_ACTIVE_CLOSE_CONVERSATIONS: 'Messages/SET_ACTIVE_CLOSE_CONVERSATIONS',
    SET_ACTIVE_EXTERNAL_CONVERSATIONS: 'Messages/SET_ACTIVE_EXTERNAL_CONVERSATIONS',
    REMOVE_CONVERSATION: 'Messages/REMOVE_CONVERSATION',
    SET_CONVERT_TICKET_ALL_CATEGORIES: 'Messages/SET_CONVERT_TICKET_ALL_CATEGORIES',
    SET_CONVERT_TICKET_ALL_TYPES: 'Messages/SET_CONVERT_TICKET_ALL_TYPES',
    SET_CONVERT_TICKET_ALL_STATES: 'Messages/SET_CONVERT_TICKET_ALL_STATES',
    SET_CONVERT_TICKET_ALL_ASSIGNEE: 'Messages/SET_CONVERT_TICKET_ALL_ASSIGNEE',
    SET_CONVERT_TICKET_ALL_WATCHERS: 'Messages/SET_CONVERT_TICKET_ALL_WATCHERS',
    SET_MESSAGE_ADMIN_ATTACHMENT: 'Messages/SET_MESSAGE_ADMIN_ATTACHMENT',
    SET_MESSAGE_ADMIN_ATTACHMENT_PDF: 'Messages/SET_MESSAGE_ADMIN_ATTACHMENT_PDF',
    TOGGLE_FOR_CONVERSATION: 'Messages/TOGGLE_FOR_CONVERSATION',
    SET_SUGGESTED_STUFF_USERS: 'Messages/SET_SUGGESTED_STUFF_USERS',
    REMOVE_FROM_SUGGESTED_STUFF_USERS: 'Messages/REMOVE_FROM_SUGGESTED_STUFF_USERS',
    FRESH_CONVERSATION: 'Messages/FRESH_CONVERSATION',
    REMOVE_NON_EXISTING_CONVERSATIONS: 'Messages/REMOVE_NON_EXISTING_CONVERSATIONS',
    RESET_MESSAGES_STORE_STATE: 'Messages/RESET_MESSAGES_STORE_STATE',

    // User
    SET_LAST_VERSION: 'User/SET_LAST_VERSION',
    SET_CURRENT_VERSION: 'User/SET_CURRENT_VERSION',
    SET_AVAILABLE_UPDATE_URL: 'User/SET_AVAILABLE_UPDATE_URL',
    SET_AVAILABLE_UPDATE_VISIBILITY: 'User/SET_AVAILABLE_UPDATE_VISIBILITY',
    LOGGED_IN: 'User/LOGGED_IN',
    LOGGED_OUT: 'User/LOGGED_OUT',
    UPDATE_EMAIL: 'User/UPDATE_EMAIL',
    UPDATE_PASSWORD: 'User/UPDATE_PASSWORD',
    UPDATE_AUTH_DATA: 'User/UPDATE_AUTH_DATA',
    UPDATE_PERSON_DATA: 'User/UPDATE_PERSON_DATA',
    UPDATE_ADDRESS: 'User/UPDATE_ADDRESS',
    UPDATE_COUNTRY: 'User/UPDATE_COUNTRY',
    UPDATE_ZIPCODE: 'User/UPDATE_ZIPCODE',
    UPDATE_CITY: 'User/UPDATE_CITY',
    UPDATE_PHONENUMBER: 'User/UPDATE_PHONENUMBER',
    UPDATE_FIRM: 'User/UPDATE_FIRM',
    UPDATE_FAMILY_NAME: 'User/UPDATE_FAMILY_NAME',
    UPDATE_FIRST_NAME: 'User/UPDATE_FIRST_NAME',
    ADD_USER_TO_CACHE: 'User/ADD_USER_TO_CACHE',
    UPDATE_CACHED_PERSON_DATA: 'User/UPDATE_CACHED_PERSON_DATA',
    ADD_USERS_TO_CACHE: 'User/ADD_USERS_TO_CACHE',
    ADD_USER_ROLES: 'User/ADD_USER_ROLES',
    ADD_ASSOCIATED_USERS: 'User/ADD_ASSOCIATED_USERS',
    UPDATE_PASSWORD_EMAIL: 'User/UPDATE_PASSWORD_EMAIL',
    UPDATE_RESPONSE_CODE: 'User/UPDATE_RESPONSE_CODE',
    UPDATE_PASSWORD_RESET_EMAIL: 'User/UPDATE_PASSWORD_RESET_EMAIL',
    PASSWORD_RESET_SUCCESS: 'User/PASSWORD_RESET_SUCCESS',
    PASSWORD_RESET_FAILURE: 'User/PASSWORD_RESET_FAILURE',
    RESET_RESET_PASSWORD: 'User/RESET_RESET_PASSWORD',
    SET_CURRENT_PROFILE_IMAGE: 'User/SET_CURRENT_PROFILE_IMAGE',
    SET_FIREBASE_TOKEN: 'User/SET_FIREBASE_TOKEN',
    SET_MINIATURE_IMAGE: 'User/SET_MINIATURE_IMAGE',
    INITIALIZE_PASSWORD_CHANGE: 'User/INITIALIZE_PASSWORD_CHANGE',
    SET_PASSWORD_CHANGE_RESPONSE: 'User/SET_PASSWORD_CHANGE_RESPONSE',
    COMPLETE_PASSWORD_CHANGE: 'User/COMPLETE_PASSWORD_CHANGE',
    SET_LOGGING_IN: 'User/SET_LOGGING_IN',
    SET_PIN_INPUT: 'User/SET_PIN_INPUT',
    ADD_PIN_DIGIT: 'User/ADD_PIN_DIGIT',
    SET_ADMIN_PROFILE_UPDATE_RESPONSE: 'User/SET_ADMIN_PROFILE_UPDATE_RESPONSE',
    SET_NEW_PROFILE_PICTURE: 'User/SET_NEW_PROFILE_PICTURE',
    SET_STAFF_NOTIFICATIONS: 'User/SET_STAFF_NOTIFICATIONS',
    SET_DASHBOARD_ITEMS_PER_PAGE_COUNT: 'User/SET_DASHBOARD_ITEMS_PER_PAGE_COUNT',
    SET_WRONG_PIN_COUNTER: 'User/SET_WRONG_PIN_COUNTER',
    RESET_USER_STORE_STATE: 'User/RESET_USER_STORE_STATE',
    UPDATE_SELECTED_LANGUAGE_CODE: 'User/UPDATE_SELECTED_LANGUAGE_CODE',
    UPDATE_CORPORATION_DEFAULT_LANGUAGE: 'User/UPDATE_CORPORATION_DEFAULT_LANGUAGE',

    // Camera
    SET_CAMERA_DIALOG_VISIBILITY: 'Camera/SET_CAMERA_DIALOG_VISIBILITY',
    SAVE_CAPTURED_IMAGE_DATA: 'Camera/SAVE_CAPTURED_IMAGE_DATA',
    RESET_CAPTURED_IMAGE_DATA: 'Camera/RESET_CAPTURED_IMAGE_DATA',
    SET_PHOTO_RECIPIENT: 'Camera/SET_PHOTO_RECIPIENT',
    RESET_CAMERA_STORE_STATE: 'Camera/RESET_CAMERA_STORE_STATE',

    // Images
    ADD_REMOTE_IMAGE: 'Images/ADD_REMOTE_IMAGE',
    ADD_ORIGINAL_IMAGE: 'Images/ADD_ORIGINAL_IMAGE',
    SET_THUMBNAIL_IMAGE_DATA: 'Images/SET_THUMBNAIL_IMAGE_DATA',
    SET_LARGE_IMAGE_DATA: 'Images/SET_LARGE_IMAGE_DATA',
    SET_ORIGINAL_IMAGE_DATA: 'Images/SET_ORIGINAL_IMAGE_DATA',
    SET_DOCUMENT_PREVIEW_DATA: 'Images/SET_DOCUMENT_PREVIEW_DATA',
    ADD_ACTIVE_FULLSCREEN_IMAGE: 'Images/ADD_ACTIVE_FULLSCREEN_IMAGE',
    IS_FULLSCREEN: 'Images/IS_FULLSCREEN',
    SHOW_IMAGE_CROPPER: 'Images/SHOW_IMAGE_CROPPER',
    HIDE_IMAGE_CROPPER: 'Images/HIDE_IMAGE_CROPPER',
    ADD_PROFILE_IMAGE: 'Images/ADD_PROFILE_IMAGE',
    SHOW_IMAGE_VIEWER: 'Images/SHOW_IMAGE_VIEWER',
    HIDE_IMAGE_VIEWER: 'Images/HIDE_IMAGE_VIEWER',
    RESET_IMAGES_STORE_STATE: 'Images/RESET_IMAGES_STORE_STATE',

    // Viewport
    SET_IS_REQUIRE_AUTO_HEIGHT: 'Viewport/SET_IS_REQUIRE_AUTO_HEIGHT',
    SET_VIEWPORT_DETAILS: 'Viewport/SET_VIEWPORT_DETAILS',
    SET_SHELF_VISIBILITY: 'Viewport/SET_SHELF_VISIBILITY',
    SET_HEADER_TEXT: 'Viewport/SET_HEADER_TEXT',
    SET_LEFT_HEADER_BUTTON: 'Viewport/SET_LEFT_HEADER_BUTTON',
    SET_RIGHT_HEADER_BUTTON: 'Viewport/SET_RIGHT_HEADER_BUTTON',
    SET_VIEW: 'Viewport/SET_VIEW',
    SET_VIEW_MODE: 'Viewport/SET_VIEW_MODE',
    SET_TRANSPARENT_HEADER: 'Viewport/SET_TRANSPARENT_HEADER',
    SET_OPAQUE_HEADER: 'Viewport/SET_OPAQUE_HEADER',
    FADE_TRANSPARENT_HEADER: 'Viewport/FADE_TRANSPARENT_HEADER',
    TOGGLE_SEARCH_FIELD: 'Viewport/TOGGLE_SEARCH_FIELD',
    SET_DEVICE_INFO: 'Viewport/SET_DEVICE_INFO',
    SET_FORM_VISIBILITY: 'Viewport/SET_FORM_VISIBILITY',
    SET_CURRENT_FORM: 'Viewport/SET_CURRENT_FORM',
    SET_CURRENT_ITEM_ID: 'Viewport/SET_CURRENT_ITEM_ID',
    ADD_ERROR_RESPONSE: 'Viewport/ADD_ERROR_RESPONSE',
    DISMISS_CURRENT_ERROR_MESSAGE: 'Viewport/DISMISS_CURRENT_ERROR_MESSAGE',
    SET_BOTTOM_MENU_VISIBILITY: 'Viewport/SET_BOTTOM_MENU_VISIBILITY',
    DISMISS_TERMS: 'Viewport/DISMISS_TERMS',
    SHOW_TERMS: 'Viewport/SHOW_TERMS',
    SHOW_CHANGE_PASSWORD: 'Viewport/SHOW_CHANGE_PASSWORD',
    SHOW_SET_PIN: 'Viewport/SHOW_SET_PIN',
    SET_BOTTOM_NAVIGATION_CLOSE_BUTTON: 'Viewport/SET_BOTTOM_NAVIGATION_CLOSE_BUTTON',
    SET_GLOBAL_OVERLAY_VISIBILITY: 'Viewport/SET_GLOBAL_OVERLAY_VISIBILITY',
    SET_GLOBAL_OVERLAY_COMPONENT: 'Viewport/SET_GLOBAL_OVERLAY_COMPONENT',
    SET_GLOBAL_OVERLAY_WAS_OPENED_LOCALLY: 'Viewport/SET_GLOBAL_OVERLAY_WAS_OPENED_LOCALLY',
    RESET_VIEWPORT_STORE_STATE: 'Viewport/RESET_VIEWPORT_STORE_STATE',
    SET_ADD_ACTION_BUTTON: 'Viewport/SET_ADD_ACTION_BUTTON',

    // Notifications
    ADD_CALENDAR_EVENT: 'Notifications/ADD_CALENDAR_EVENT',
    ADD_NOTIFICATION: 'Notifications/ADD_NOTIFICATION',
    ADD_NOTIFICATION_ADMIN: 'Notifications/ADD_NOTIFICATION_ADMIN',
    ADD_NOTIFICATIONS: 'Notifications/ADD_NOTIFICATIONS',
    UPDATE_ACTIVE_NOTIFICATION: 'Notifications/UPDATE_ACTIVE_NOTIFICATION',
    EDIT_ACTIVE_NOTIFICATION: 'Notifications/EDIT_ACTIVE_NOTIFICATION',
    UPDATE_NOTIFICATION_TITLE: 'Notifications/UPDATE_NOTIFICATION_TITLE',
    UPDATE_NOTIFICATION_PUBLISHED_AT: 'Notifications/UPDATE_NOTIFICATION_PUBLISHED_AT',
    UPDATE_NOTIFICATION_DESCRIPTION: 'Notifications/UPDATE_NOTIFICATION_DESCRIPTION',
    UPDATE_NOTIFICATION_EVENT_TITLE: 'Notifications/UPDATE_NOTIFICATION_EVENT_TITLE',
    UPDATE_NOTIFICATION_EVENT_DESCRIPTION: 'Notifications/UPDATE_NOTIFICATION_EVENT_DESCRIPTION',
    UPDATE_NOTIFICATION_EVENT_START_TIME: 'Notifications/UPDATE_NOTIFICATION_EVENT_START_TIME',
    UPDATE_NOTIFICATION_EVENT_END_TIME: 'Notifications/UPDATE_NOTIFICATION_EVENT_END_TIME',
    MARK_NOTIFICATION_AS_SEEN: 'Notifications/MARK_NOTIFICATION_AS_SEEN',
    TOGGLE_EVENT_FIELDS: 'Notifications/TOGGLE_EVENT_FIELDS',
    SHOW_EDIT_NOTIFICATION_FORM: 'Notifications/SHOW_EDIT_NOTIFICATION_FORM',
    HIDE_EDIT_NOTIFICATION_FORM: 'Notifications/HIDE_EDIT_NOTIFICATION_FORM',
    INITIATE_NEW_NOTIFICATION: 'Notifications/INITIATE_NEW_NOTIFICATION',
    SORT_ALL_NOTIFICATIONS: 'Notifications/SORT_ALL_NOTIFICATIONS',
    DELETE_SINGLE_NOTIFICATION: 'Notifications/DELETE_SINGLE_NOTIFICATION',
    SET_ACTIVE_NOTIFICATION_MEDIA: 'Notifications/SET_ACTIVE_NOTIFICATION_MEDIA',
    ADD_DASHBOARD_NOTIFICATION_IMAGES: 'Notifications/ADD_DASHBOARD_NOTIFICATION_IMAGES',
    UPDATE_ORDER_NOTIFICATION: 'Notifications/UPDATE_ORDER_NOTIFICATION',
    SET_ADMIN_NOTIFICATION_DATA_LOAD_STATUS: 'Notifications/SET_ADMIN_NOTIFICATION_DATA_LOAD_STATUS',
    SET_APP_DASHBOARD_NOTIFICATION_PAGE: 'Notifications/SET_APP_DASHBOARD_NOTIFICATION_PAGE',
    SET_NOTIFICATION_ID_FOR_SCROLL: 'Notifications/SET_NOTIFICATION_ID_FOR_SCROLL',
    SET_NOTIFICATION_ACTIVE_TAB: 'Notifications/SET_NOTIFICATION_ACTIVE_TAB',
    RESET_NOTIFICATIONS_STORE_STATE: 'Notifications/RESET_NOTIFICATIONS_STORE_STATE',

    // Recipients
    SET_SELECTED_RECIPIENTS: 'Recipients/SET_SELECTED_RECIPIENTS',
    SET_FOR_WHOLE_CORPORATION: 'Recipients/SET_FOR_WHOLE_CORPORATION',
    SET_RECIPIENT_REQUIRED: 'Recipients/SET_RECIPIENT_REQUIRED',
    SET_RECIPIENTS_VISIBILITY: 'Recipients/SET_RECIPIENTS_VISIBILITY',
    RESET_RECIPIENT: 'Recipients/RESET_RECIPIENT',
    RESET_RECIPIENTS: 'Recipients/RESET_RECIPIENTS',
    SET_TARGETED_RECIPIENTS_MODAL_VISIBILITY: 'Recipients/SET_TARGETED_RECIPIENTS_MODAL_VISIBILITY',
    SET_TARGETED_RECIPIENTS: 'Recipients/SET_TARGETED_RECIPIENTS',

    // Events
    ADD_EVENT: 'Events/ADD_EVENT',
    ADD_EVENT_ADMIN: 'Events/ADD_EVENT_ADMIN',
    ADD_EVENTS: 'Events/ADD_EVENTS',
    ADD_ADMIN_EVENT: 'Events/ADD_ADMIN_EVENT', // TODO: delete later - testing
    EDIT_ACTIVE_EVENT: 'Events/EDIT_ACTIVE_EVENT',
    UPDATE_ACTIVE_EVENT: 'Events/UPDATE_ACTIVE_EVENT',
    UPDATE_EVENT_TITLE: 'Events/UPDATE_EVENT_TITLE',
    UPDATE_EVENT_CREATION_DATE: 'Events/UPDATE_EVENT_CREATION_DATE',
    UPDATE_EVENT_START_TIME: 'Events/UPDATE_EVENT_START_TIME',
    UPDATE_EVENT_END_TIME: 'Events/UPDATE_EVENT_END_TIME',
    UPDATE_EVENT_ADDRESS: 'Events/UPDATE_EVENT_ADDRESS',
    UPDATE_EVENT_CITY: 'Events/UPDATE_EVENT_CITY',
    UPDATE_EVENT_ZIP_CODE: 'Events/UPDATE_EVENT_ZIP_CODE',
    UPDATE_EVENT_COUNTRY: 'Events/UPDATE_EVENT_COUNTRY',
    UPDATE_EVENT_DESCRIPTION: 'Events/UPDATE_EVENT_DESCRIPTION',
    SHOW_EDIT_EVENT_FORM: 'Events/SHOW_EDIT_EVENT_FORM',
    HIDE_EDIT_EVENT_FORM: 'Events/HIDE_EDIT_EVENT_FORM',
    INITIATE_NEW_EVENT: 'Events/INITIATE_NEW_EVENT',
    ACCEPT_CALENDAR_ACCESS: 'Events/ACCEPT_CALENDAR_ACCESS',
    REQUESTED_CALENDAR_ACCESS: 'Events/REQUESTED_CALENDAR_ACCESS',
    SET_DEVICE_CALENDAR_NAME: 'Events/SET_DEVICE_CALENDAR_NAME',
    SET_DEVICE_CALENDARS: 'Events/SET_DEVICE_CALENDARS',
    UPDATE_PERSISTED_EVENT: 'Events/UPDATE_PERSISTED_EVENT',
    UPDATE_CACHED_EVENT: 'Events/UPDATE_CACHED_EVENT',
    ATTENDING_CALENDAR_EVENT: 'Events/ATTENDING_CALENDAR_EVENT',
    UPDATE_REQUIRES_RESPONSE: 'Events/UPDATE_REQUIRES_RESPONSE',
    DELETE_SINGLE_EVENT: 'Events/DELETE_SINGLE_EVENT',
    SORT_ALL_EVENTS: 'Events/SORT_ALL_EVENTS',
    SET_ACTIVE_EVENT_MEDIA: 'Events/SET_ACTIVE_EVENT_MEDIA',
    RESET_EVENT_ATTENDEES: 'Events/RESET_EVENT_ATTENDEES',
    SET_EVENT_ATTENDEES: 'Events/SET_EVENT_ATTENDEES',
    ADD_EVENT_ATTENDEE: 'Events/ADD_EVENT_ATTENDEE',
    REMOVE_EVENT_ATTENDEE: 'Events/REMOVE_EVENT_ATTENDEE',
    RESET_EVENTS_STORE_STATE: 'Events/RESET_EVENTS_STORE_STATE',

    // Documents admin
    SET_ADMIN_DOCUMENTS: 'Documents/SET_ADMIN_DOCUMENTS',
    SET_ADMIN_DOCUMENT: 'Documents/SET_ADMIN_DOCUMENT',
    SET_CURRENT_DOCUMENT: 'Documents/SET_CURRENT_DOCUMENT',
    SET_DOCUMENT_SEARCH_OPTION: 'Documents/SET_DOCUMENT_SEARCH_OPTION',
    SET_DOCUMENT_COLUMN_OPTION: 'Documents/SET_DOCUMENT_COLUMN_OPTION',
    SET_DOCUMENT_DIR_OPTION: 'Documents/SET_DOCUMENT_DIR_OPTION',
    SET_PREVIEW_MEDIA: 'Documents/SET_PREVIEW_MEDIA',
    SET_PREVIEW_MEDIA_VISIBILITY: 'Documents/SET_PREVIEW_MEDIA_VISIBILITY',
    REMOVE_CURRENT_DOCUMENT: 'Documents/REMOVE_CURRENT_DOCUMENT',
    SET_DOCUMENT_PROJECT_OPTION: 'Documents/SET_DOCUMENT_PROJECT_OPTION',
    RESET_DOCUMENTS_STORE_STATE: 'Documents/RESET_DOCUMENTS_STORE_STATE',

    // Documents user
    SET_USER_DOCUMENTS: 'Documents/SET_USER_DOCUMENTS',
    SET_ACTIVE_DOCUMENT: 'Documents/SET_ACTIVE_DOCUMENT',
    MARK_DOCUMENT_AS_SIGNED: 'Documents/MARK_DOCUMENT_AS_SIGNED',
    MARK_DOCUMENT_AS_SEEN: 'Documents/MARK_DOCUMENT_AS_SEEN',

    // Options
    SELECT_ITEM: 'Options/SELECT_ITEM',
    DESELECT_ITEM: 'Options/DESELECT_ITEM',
    ADD_OPTION: 'Options/ADD_OPTION',
    UPDATE_ACTIVE_OPTION: 'Options/UPDATE_ACTIVE_OPTION',
    RESET_OPTIONS_STORE_STATE: 'Options/RESET_OPTIONS_STORE_STATE',

    // Socket
    SET_SOCKET_STATUS: 'Socket/SET_SOCKET_STATUS',
    CONVERSATION_SOCKET_INITIALIZED: 'Socket/CONVERSATION_SOCKET_INITIALIZED',
    TICKET_SOCKET_INITIALIZED: 'Socket/TICKET_SOCKET_INITIALIZED',
    IDENTITY_SOCKET_INITIALIZED: 'Socket/IDENTITY_SOCKET_INITIALIZED',
    RESET_SOCKET_STORE_STATE: 'Socket/RESET_SOCKET_STORE_STATE',
    SET_TENANT_LOG_SOCKET_INITIALIZED: 'Socket/SET_TENANT_LOG_SOCKET_INITIALIZED',
    RESET_SOCKET_INITIALIZATIONS: 'Socket/RESET_SOCKET_INITIALIZATIONS',

    // Feedback
    SET_FEEDBACK_RATING: 'Feedback/SET_FEEDBACK_RATING',
    SET_FEEDBACK_COMMENT: 'Feedback/SET_FEEDBACK_COMMENT',
    HIDE_FEEDBACK_DIALOG: 'Feedback/HIDE_FEEDBACK_DIALOG',
    SHOW_FEEDBACK_DIALOG: 'Feedback/SHOW_FEEDBACK_DIALOG',
    ADD_FEEDBACK_EVENTS: 'Feedback/ADD_FEEDBACK_EVENTS',
    RESET_FEEDBACK_STORE_STATE: 'Feedback/RESET_FEEDBACK_STORE_STATE',

    // Localization
    SET_ALL_LANGUAGES: 'Localization/SET_ALL_LANGUAGES',
    SET_LANGUAGE_ALL_TEXTS: 'Localization/SET_LANGUAGE_ALL_TEXTS',
    SET_LANGUAGE_OPTION: 'Localization/SET_LANGUAGE_OPTION',
    SET_LOCALIZATION_SEARCH_OPTION: 'Localization/SET_LOCALIZATION_SEARCH_OPTION',
    UPDATE_TEXT_CONTENT: 'Localization/UPDATE_TEXT_CONTENT',
    SET_LOCALIZATION_KEY: 'Localization/SET_LOCALIZATION_KEY',
    ADD_LANGUAGE_KEY: 'Localization/ADD_LANGUAGE_KEY',
    SET_ADD_LANGUAGE_VISIBILITY: 'Localization/SET_ADD_LANGUAGE_VISIBILITY',
    SET_ADD_LANGUAGE_KEY_VISIBILITY: 'Localization/SET_ADD_LANGUAGE_KEY_VISIBILITY',
    SET_IMPORT_LANGUAGE_CSV_VISIBILITY: 'Localization/SET_IMPORT_LANGUAGE_CSV_VISIBILITY',
    RESET_LOCALIZATION_STORE_STATE: 'Localization/RESET_LOCALIZATION_STORE_STATE',

    // Projects
    ADD_PROJECT: 'Projects/ADD_PROJECT',
    ADD_PROJECTS: 'Projects/ADD_PROJECTS',
    UPDATE_PROJECT_NAME: 'Projects/UPDATE_PROJECT_NAME',
    UPDATE_PROJECT_OWNER: 'Projects/UPDATE_PROJECT_OWNER',
    UPDATE_PROJECT_DESCRIPTION: 'Projects/UPDATE_PROJECT_DESCRIPTION',
    UPDATE_ACTIVE_PROJECT: 'Projects/UPDATE_ACTIVE_PROJECT',
    EDIT_ACTIVE_PROJECT: 'Projects/EDIT_ACTIVE_PROJECT',
    INITIATE_NEW_PROJECT: 'Projects/INITIATE_NEW_PROJECT',
    SHOW_EDIT_PROJECT_FORM: 'Projects/SHOW_EDIT_PROJECT_FORM',
    HIDE_EDIT_PROJECT_FORM: 'Projects/HIDE_EDIT_PROJECT_FORM',
    SELECT_PROJECT: 'Projects/SELECT_PROJECT',
    SET_SELECTED_PROJECT: 'Projects/SET_SELECTED_PROJECT',
    DESELECT_PROJECT: 'Projects/DESELECT_PROJECT',
    UPDATE_PERSISTED_PROJECT: 'Projects/UPDATE_PERSISTED_PROJECT',
    UPDATE_PROJECT_COMPANY_CONTACT: 'Projects/UPDATE_PROJECT_COMPANY_CONTACT',
    SET_PROJECT_TO_EDIT: 'Projects/SET_PROJECT_TO_EDIT',
    UPDATE_CACHED_PROJECT: 'Projects/UPDATE_CACHED_PROJECT',
    UPDATE_SELECTED_PROJECT: 'Projects/UPDATE_SELECTED_PROJECT',
    SET_PROJECT_CONFIGS: 'Projects/SET_PROJECT_CONFIGS',
    RESET_PROJECTS_STORE_STATE: 'Projects/RESET_PROJECTS_STORE_STATE',

    // Buildings
    ADD_BUILDING: 'Buildings/ADD_BUILDING',
    ADD_BUILDINGS: 'Buildings/ADD_BUILDINGS',
    UPDATE_BUILDING_NAME: 'Buildings/UPDATE_BUILDING_NAME',
    UPDATE_BUILDING_MANAGER: 'Buildings/UPDATE_BUILDING_MANAGER',
    UPDATE_BUILDING_STAFF: 'Buildings/UPDATE_BUILDING_STAFF',
    UPDATE_BUILDING_PROJECT_ID: 'Buildings/UPDATE_BUILDING_PROJECT_ID',
    SHOW_BUILDING_USER_SUGGESTIONS: 'Buildings/SHOW_BUILDING_USER_SUGGESTIONS',
    HIDE_USER_SUGGESTIONS: 'Buildings/HIDE_USER_SUGGESTIONS',
    ADD_BUILDING_MANAGER_SUGGESTIONS: 'Buildings/ADD_BUILDING_MANAGER_SUGGESTIONS',
    UPDATE_ACTIVE_BUILDING: 'Buildings/UPDATE_ACTIVE_BUILDING',
    EDIT_ACTIVE_BUILDING: 'Buildings/EDIT_ACTIVE_BUILDING',
    INITIATE_NEW_BUILDING: 'Buildings/INITIATE_NEW_BUILDING',
    SHOW_EDIT_BUILDING_FORM: 'Buildings/SHOW_EDIT_BUILDING_FORM',
    HIDE_EDIT_BUILDING_FORM: 'Buildings/HIDE_EDIT_BUILDING_FORM',
    SELECT_BUILDING: 'Buildings/SELECT_BUILDING',
    DESELECT_BUILDING: 'Buildings/DESELECT_BUILDING',
    RESET_BUILDING_SELECTION: 'Buildings/RESET_BUILDING_SELECTION',
    REMOVE_MANAGER_FROM_ACTIVE_BUILDING: 'Buildings/REMOVE_MANAGER_FROM_ACTIVE_BUILDING',
    REMOVE_MANAGER_FROM_BUILDING: 'Buildings/REMOVE_MANAGER_FROM_BUILDING',
    SET_MANAGER_SEARCH_QUERY: 'Buildings/SET_MANAGER_SEARCH_QUERY',
    CANCEL_EDIT_BUILDING: 'Buildings/CANCEL_EDIT_BUILDING',
    ADD_BUILDING_MANAGER: 'Buildings/ADD_BUILDING_MANAGER',
    UPDATE_PERSISTED_BUILDING: 'Buildings/UPDATE_PERSISTED_BUILDING',
    RESET_BUILDINGS_STORE_STATE: 'Buildings/RESET_BUILDINGS_STORE_STATE',

    // User Management
    SET_CONTACT_US_VISIBILITY: 'UserManagement/SET_CONTACT_US_VISIBILITY',
    SET_ADD_TENANT_VISIBILITY: 'UserManagement/SET_ADD_TENANT_VISIBILITY',
    SET_ADD_TENANT_FORM_MODE: 'UserManagement/SET_ADD_TENANT_FORM_MODE',
    SET_ADD_UPCOMING_TENANT_VISIBILITY: 'UserManagement/SET_ADD_UPCOMING_TENANT_VISIBILITY',
    SET_ADD_UPCOMING_GUEST_VISIBILITY: 'UserManagement/SET_ADD_UPCOMING_GUEST_VISIBILITY',
    SET_ADD_STAFF_VISIBILITY: 'UserManagement/SET_ADD_STAFF_VISIBILITY',
    SET_EDIT_TENANT_VISIBILITY: 'UserManagement/SET_EDIT_TENANT_VISIBILITY',
    SET_EDIT_STAFF_VISIBILITY: 'UserManagement/SET_EDIT_STAFF_VISIBILITY',
    SET_ADD_OWNERSHIP_VISIBILITY: 'UserManagement/SET_ADD_OWNERSHIP_VISIBILITY',
    SET_REASSIGNE_TENANT_USER_VISIBILITY: 'UserManagement/SET_REASSIGNE_TENANT_USER_VISIBILITY',
    SET_INACTIVE_USER_ID: 'UserManagement/SET_INACTIVE_USER_ID',
    SET_USER_MANAGEMENT_ALL_STAFF_ROLES: 'UserManagement/SET_USER_MANAGEMENT_ALL_STAFF_ROLES',
    SET_USER_MANAGEMENT_ALL_STAFF_USERS: 'UserManagement/SET_USER_MANAGEMENT_ALL_STAFF_USERS',
    SET_USER_MANAGEMENT_ALL_TENANT_USERS: 'UserManagement/SET_USER_MANAGEMENT_ALL_TENANT_USERS',
    SET_CURRENT_TENANT_USER: 'UserManagement/SET_CURRENT_TENANT_USER',
    SET_CURRENT_STAFF_USER: 'UserManagement/SET_CURRENT_STAFF_USER',
    SET_CURRENT_DELETE_USER: 'UserManagement/SET_CURRENT_DELETE_USER',
    SET_NEW_TENANT_PROJECT_WITH_UNIT: 'UserManagement/SET_NEW_TENANT_PROJECT_WITH_UNIT',
    RESET_NEW_TENANT_PROJECT_WITH_UNIT: 'UserManagement/RESET_NEW_TENANT_PROJECT_WITH_UNIT',
    SET_ACTIVE_UPCOMING_TENANT: 'UserManagement/SET_ACTIVE_UPCOMING_TENANT',
    SET_ACTIVE_UPCOMING_GUEST: 'UserManagement/SET_ACTIVE_UPCOMING_GUEST',
    SET_USER_MANAGEMENT_STATUS_OPTION: 'UserManagement/SET_USER_MANAGEMENT_STATUS_OPTION',
    REMOVE_SOCIAL_TAG: 'UserManagement/REMOVE_SOCIAL_TAG',
    ADD_SOCIAL_TAG: 'UserManagement/ADD_SOCIAL_TAG',
    REMOVE_EDUCATIONAL_TAG: 'UserManagement/REMOVE_EDUCATIONAL_TAG',
    ADD_EDUCATIONAL_TAG: 'UserManagement/ADD_EDUCATIONAL_TAG',
    REMOVE_APPLICATION_EDUCATIONAL_TAG: 'UserManagement/REMOVE_APPLICATION_EDUCATIONAL_TAG',
    ADD_APPLICATION_EDUCATIONAL_TAG: 'UserManagement/ADD_APPLICATION_EDUCATIONAL_TAG',
    REMOVE_APPLICATION_SOCIAL_TAG: 'UserManagement/REMOVE_APPLICATION_SOCIAL_TAG',
    ADD_APPLICATION_SOCIAL_TAG: 'UserManagement/ADD_APPLICATION_SOCIAL_TAG',
    RESET_PROFILING_APPLICATION_VARIANTS_AND_BUILDINGS: 'UserManagement/RESET_PROFILING_APPLICATION_VARIANTS_AND_BUILDINGS',
    SET_REVERT_UPCOMING_TENANT_APPLICATION_VISIBLE: 'UserManagement/SET_REVERT_UPCOMING_TENANT_APPLICATION_VISIBLE',
    SET_CANCEL_UPCOMING_TENANT_MOVE_IN_VISIBLE: 'UserManagement/SET_CANCEL_UPCOMING_TENANT_MOVE_IN_VISIBLE',
    SET_CANCEL_UPCOMING_GUEST_MOVE_IN_VISIBLE: 'UserManagement/SET_CANCEL_UPCOMING_GUEST_MOVE_IN_VISIBLE',
    RESET_USER_MANAGEMENT_STORE_STATE: 'UserManagement/RESET_USER_MANAGEMENT_STORE_STATE',

    // Properties
    ADD_PROPERTY: 'Properties/ADD_PROPERTY',
    ADD_PROPERTY_USER: 'Properties/ADD_PROPERTY_USER',
    ADD_PROPERTIES: 'Properties/ADD_PROPERTIES',
    ADD_COUNTRIES: 'Properties/ADD_COUNTRIES',
    ADD_PROPERTY_TENANT_TO_CACHE: 'Properties/ADD_PROPERTY_TENANT_TO_CACHE',
    REMOVE_PROPERTY_TENANT_FROM_CACHE: 'Properties/REMOVE_PROPERTY_TENANT_FROM_CACHE',
    REFRESH_PROPERTY_CACHED_TENANTS: 'Properties/REFRESH_PROPERTY_CACHED_TENANTS',
    UPDATE_PROPERTY_ADDRESS: 'Properties/UPDATE_PROPERTY_ADDRESS',
    UPDATE_PROPERTY_CITY: 'Properties/UPDATE_PROPERTY_CITY',
    UPDATE_PROPERTY_ZIP_CODE: 'Properties/UPDATE_PROPERTY_ZIP_CODE',
    UPDATE_PROPERTY_FLOOR: 'Properties/UPDATE_PROPERTY_FLOOR',
    UPDATE_PROPERTY_TYPE: 'Properties/UPDATE_PROPERTY_TYPE',
    UPDATE_PROPERTY_MANAGER: 'Properties/UPDATE_PROPERTY_MANAGER',
    UPDATE_PROPERTY_MANAGER_NAME: 'Properties/UPDATE_PROPERTY_MANAGER_NAME',
    UPDATE_PROPERTY_VARIANT_ID: 'Properties/UPDATE_PROPERTY_VARIANT_ID',
    UPDATE_PROPERTY_COUNTRY_ID: 'Properties/UPDATE_PROPERTY_COUNTRY_ID',
    UPDATE_PROPERTY_BUILDING_ID: 'Properties/UPDATE_PROPERTY_BUILDING_ID',
    UPDATE_PROPERTY_BUYER_NAME: 'Properties/UPDATE_PROPERTY_BUYER_NAME',
    UPDATE_PROPERTY_BUYER_EMAIL: 'Properties/UPDATE_PROPERTY_BUYER_EMAIL',
    UPDATE_PROPERTY_RENT: 'Properties/UPDATE_PROPERTY_RENT',
    UPDATE_PROPERTY_DEPOSIT: 'Properties/UPDATE_PROPERTY_DEPOSIT',
    UPDATE_ACTIVE_PROPERTY: 'Properties/UPDATE_ACTIVE_PROPERTY',
    UPDATE_PROPERTY_WATER_COST: 'Properties/UPDATE_PROPERTY_WATER_COST',
    UPDATE_PROPERTY_HEATING_COST: 'Properties/UPDATE_PROPERTY_HEATING_COST',
    UPDATE_PROPERTY_AREA: 'Properties/UPDATE_PROPERTY_AREA',
    UPDATE_PROPERTY_ROOMS: 'Properties/UPDATE_PROPERTY_ROOMS',
    UPDATE_PROPERTY_POWER_COST: 'Properties/UPDATE_PROPERTY_POWER_COST',
    UPDATE_PROPERTY_INTERNET_COST: 'Properties/UPDATE_PROPERTY_INTERNET_COST',
    UPDATE_PROPERTY_PREPAID_RENT: 'Properties/UPDATE_PROPERTY_PREPAID_RENT',
    UPDATE_PROPERTY_FUTURE_RENT: 'Properties/UPDATE_PROPERTY_FUTURE_RENT',
    UPDATE_PROPERTY_TOTAL_PAID: 'Properties/UPDATE_PROPERTY_TOTAL_PAID',
    UPDATE_PROPERTY_UNIT_TYPE_UB: 'Properties/UPDATE_PROPERTY_UNIT_TYPE_UB',
    UPDATE_PROPERTY_VACANT_FROM_DATE: 'Properties/UPDATE_PROPERTY_VACANT_FROM_DATE',
    UPDATE_PROPERTY_RELEASE_DATE: 'Properties/UPDATE_PROPERTY_RELEASE_DATE',
    UPDATE_PROPERTY_MOVING_IN_DATE: 'Properties/UPDATE_PROPERTY_MOVING_IN_DATE',
    EDIT_ACTIVE_PROPERTY: 'Properties/EDIT_ACTIVE_PROPERTY',
    INITIATE_NEW_PROPERTY: 'Properties/INITIATE_NEW_PROPERTY',
    SHOW_EDIT_PROPERTY_FORM: 'Properties/SHOW_EDIT_PROPERTY_FORM',
    HIDE_EDIT_PROPERTY_FORM: 'Properties/HIDE_EDIT_PROPERTY_FORM',
    ADD_PROPERTY_MANAGER_SUGGESTIONS: 'Properties/ADD_PROPERTY_MANAGER_SUGGESTIONS',
    SHOW_PROPERTY_USER_SUGGESTIONS: 'Properties/SHOW_PROPERTY_USER_SUGGESTIONS',
    HIDE_PROPERTY_USER_SUGGESTIONS: 'Properties/HIDE_PROPERTY_USER_SUGGESTIONS',
    SHOW_ADD_USER_TO_PROPERTY_FORM: 'Properties/SHOW_ADD_USER_TO_PROPERTY_FORM',
    HIDE_ADD_USER_TO_PROPERTY_FORM: 'Properties/HIDE_ADD_USER_TO_PROPERTY_FORM',
    SELECT_PROPERTY: 'Properties/SELECT_PROPERTY',
    DESELECT_PROPERTY: 'Properties/DESELECT_PROPERTY',
    REMOVE_MANAGER_FROM_ACTIVE_PROPERTY: 'Properties/REMOVE_MANAGER_FROM_ACTIVE_PROPERTY',
    ADD_MANAGER_TO_PROPERTY: 'Properties/ADD_MANAGER_TO_PROPERTY',
    SET_PROPERTY_MANAGER_SEARCH_QUERY: 'Properties/SET_PROPERTY_MANAGER_SEARCH_QUERY',
    HIDE_PROPERTY_MANAGER_SUGGESTIONS: 'Properties/HIDE_PROPERTY_MANAGER_SUGGESTIONS',
    UPDATE_PERSISTED_PROPERTY: 'Properties/UPDATE_PERSISTED_PROPERTY',
    RESET_PROPERTY_SELECTION: 'Properties/RESET_PROPERTY_SELECTION',
    UPDATE_PROPERTY_TITLE_NUMBER: 'Properties/UPDATE_PROPERTY_TITLE_NUMBER',
    UPDATE_PROPERTY_COMPANY_NUMBER: 'Properties/UPDATE_PROPERTY_COMPANY_NUMBER',
    UPDATE_PROPERTY_COMMERCIAL_TYPE: 'Properties/UPDATE_PROPERTY_COMMERCIAL_TYPE',
    UPDATE_PROPERTY_COMPANY_NAME: 'Properties/UPDATE_PROPERTY_COMPANY_NAME',
    REMOVE_PROPERTY_TENANTS: 'Properties/REMOVE_PROPERTY_TENANTS',
    UPDATE_PROPERTY_OWNER: 'Properties/UPDATE_PROPERTY_OWNER',
    SET_CURRENT_PROPERTY: 'Properties/SET_CURRENT_PROPERTY',
    ADD_TENANT_TO_PROPERTY: 'Properties/ADD_TENANT_TO_PROPERTY',
    UPDATE_PROPERTY_COMPANY_DATA: 'Properties/UPDATE_PROPERTY_COMPANY_DATA',
    ADD_UPCOMING_TENANT: 'Properties/ADD_UPCOMING_TENANT',
    EDIT_UPCOMING_TENANT: 'Properties/EDIT_UPCOMING_TENANT',
    ADD_UPCOMING_GUEST: 'Properties/ADD_UPCOMING_GUEST',
    EDIT_UPCOMING_GUEST: 'Properties/EDIT_UPCOMING_GUEST',
    REMOVE_TENANT_FROM_UNIT: 'Properties/REMOVE_TENANT_FROM_UNIT',
    REMOVE_DOCUMENT_FROM_UNIT: 'Properties/REMOVE_DOCUMENT_FROM_UNIT',
    ADD_PROPERTY_CONTRACT: 'Properties/ADD_PROPERTY_CONTRACT',
    ADD_PROPERTY_DOCUMENT: 'Properties/ADD_PROPERTY_DOCUMENT',
    UPDATE_PROPERTY_FLOOR_PLAN: 'Properties/UPDATE_PROPERTY_FLOOR_PLAN',
    SET_NEW_FLOOR_PLAN_SOURCE: 'Properties/SET_NEW_FLOOR_PLAN_SOURCE',
    UPDATE_ACTIVE_PROPERTY_DATES: 'Properties/UPDATE_ACTIVE_PROPERTY_DATES',
    CANCEL_EDIT_PROPERTY: 'Properties/CANCEL_EDIT_PROPERTY',
    REMOVE_UNIT: 'Properties/REMOVE_UNIT',
    UPDATE_TENANCY_PERIODS: 'Properties/UPDATE_TENANCY_PERIODS',
    UPDATE_TENANCY_PERIODS_ACTIVITY: 'Properties/UPDATE_TENANCY_PERIODS_ACTIVITY',
    RESET_PROPERTIES_STORE_STATE: 'Properties/RESET_PROPERTIES_STORE_STATE',

    // Variants
    ADD_VARIANT: 'Variants/ADD_VARIANT',
    ADD_VARIANTS: 'Variants/ADD_VARIANTS',
    ADD_VARIANT_MEDIA: 'Variants/ADD_VARIANT_MEDIA',
    ADD_VARIANT_SELECTED_MEDIA: 'Variants/ADD_VARIANT_SELECTED_MEDIA',
    UPDATE_VARIANT_PROJECT_ID: 'Variants/UPDATE_VARIANT_PROJECT_ID',
    UPDATE_VARIANT_NAME: 'Variants/UPDATE_VARIANT_NAME',
    UPDATE_VARIANT_ROOMS: 'Variants/UPDATE_VARIANT_ROOMS',
    UPDATE_VARIANT_AREA: 'Variants/UPDATE_VARIANT_AREA',
    UPDATE_VARIANT_DESCRIPTION: 'Variants/UPDATE_VARIANT_DESCRIPTION',
    UPDATE_VARIANT_FILE_NAME: 'Variants/UPDATE_VARIANT_FILE_NAME',
    UPDATE_ACTIVE_VARIANT: 'Variants/UPDATE_ACTIVE_VARIANT',
    EDIT_ACTIVE_VARIANT: 'Variants/EDIT_ACTIVE_VARIANT',
    INITIATE_NEW_VARIANT: 'Variants/INITIATE_NEW_VARIANT',
    SHOW_EDIT_VARIANT_FORM: 'Variants/SHOW_EDIT_VARIANT_FORM',
    HIDE_EDIT_VARIANT_FORM: 'Variants/HIDE_EDIT_VARIANT_FORM',
    CANCEL_EDIT_VARIANT: 'Variants/CANCEL_EDIT_VARIANT',
    REMOVE_DOCUMENT_FROM_ACTIVE_VARIANT: 'Variants/REMOVE_DOCUMENT_FROM_ACTIVE_VARIANT',
    SHOW_UPLOAD_FLOOR_PLAN_FORM: 'Variants/SHOW_UPLOAD_FLOOR_PLAN_FORM',
    HIDE_UPLOAD_FLOOR_PLAN_FORM: 'Variants/HIDE_UPLOAD_FLOOR_PLAN_FORM',
    SAVE_FLOOR_PLAN_BASE64_IMAGE_DATA: 'Variants/SAVE_FLOOR_PLAN_BASE64_IMAGE_DATA',
    UPDATE_PERSISTED_VARIANT: 'Variants/UPDATE_PERSISTED_VARIANT',
    EDIT_FLOOR_PLAN: 'Variants/EDIT_FLOOR_PLAN',
    REMOVE_VARIANT: 'Variants/REMOVE_VARIANT',
    RESET_VARIANTS_STORE_STATE: 'Variants/RESET_VARIANTS_STORE_STATE',

    // Corporations
    ADD_CORPORATIONS: 'Corporations/ADD_CORPORATIONS',
    SET_ADMIN_CURRENT_CORPORATION: 'Corporations/SET_ADMIN_CURRENT_CORPORATION',
    SET_CORPORATION_SQUARE_LOGO_URL: 'Corporations/SET_CORPORATION_SQUARE_LOGO_URL',
    CHANGE_CORPORATION_SMS_OPTION: 'Corporations/CHANGE_CORPORATION_SMS_OPTION',
    RESET_CORPORATIONS_STORE_STATE: 'Corporations/RESET_CORPORATIONS_STORE_STATE',

    // Corporation links
    SET_CORPORATION_LINKS: 'CorporationLinks/SET_CORPORATION_LINKS',

    // Editor
    RESET_EDITOR_STORE_STATE: 'Editor/RESET_EDITOR_STORE_STATE',

    // Tickets
    SET_ALL_TICKETS: 'Tickets/SET_ALL_TICKETS',
    SET_TICKET_INFO_VISIBILITY: 'Tickets/SET_TICKET_INFO_VISIBILITY',
    SET_TICKETS_STATUS_OPTION: 'Tickets/SET_TICKETS_STATUS_OPTION',
    SET_CURRENT_TICKET: 'Tickets/SET_CURRENT_TICKET',
    SET_TICKET_CONVERSATION: 'Tickets/SET_TICKET_CONVERSATION',
    SET_TICKET_IMAGE_PREVIEW_VISIBILITY: 'Tickets/SET_TICKET_IMAGE_PREVIEW_VISIBILITY',
    SET_TICKET_ALL_STATES: 'Tickets/SET_TICKET_ALL_STATES',
    SET_TICKET_ROLE_ASSIGNEE: 'Tickets/SET_TICKET_ROLE_ASSIGNEE',
    SET_TICKET_SUGGESTED_WATCHERS: 'Tickets/SET_TICKET_SUGGESTED_WATCHERS',
    SET_TICKET_CREATE_FORM_VISIBILITY: 'Tickets/SET_TICKET_CREATE_FORM_VISIBILITY',
    SET_TICKET_ADD_FORM_VISIBILITY: 'Tickets/SET_TICKET_ADD_FORM_VISIBILITY',
    SET_ADD_TICKET_PROPERTIES: 'Tickets/SET_ADD_TICKET_PROPERTIES',
    SET_ADD_TICKET_RECIEVERS: 'Tickets/SET_ADD_TICKET_RECIEVERS',
    APPEND_TICKET: 'Tickets/APPEND_TICKET',
    EXECUTE_TICKET_UPDATE: 'Tickets/EXECUTE_TICKET_UPDATE',
    ADD_SOCKET_INIT_TICKET_ID: 'Tickets/ADD_SOCKET_INIT_TICKET_ID',
    PUSH_TO_TICKET_CONVERSATION: 'Tickets/PUSH_TO_TICKET_CONVERSATION',
    REMOVE_TICKET_CONVERSATION_MESSAGE: 'Tickets/REMOVE_TICKET_CONVERSATION_MESSAGE',
    UPDATE_TICKET_STATE: 'Tickets/UPDATE_TICKET_STATE',
    UPDATE_TICKET_ASSIGNEE: 'Tickets/UPDATE_TICKET_ASSIGNEE',
    SET_TICKET_PRIORITY: 'Tickets/SET_TICKET_PRIORITY',
    MAKE_TICKET_RESPONDED: 'Tickets/MAKE_TICKET_RESPONDED',
    RESET_TICKETS_STORE_STATE: 'Tickets/RESET_TICKETS_STORE_STATE',

    // Ticket Attributes
    SET_ADD_CATEGORY_VISIBILITY: 'TicketAttributes/SET_ADD_CATEGORY_VISIBILITY',
    SET_ADD_INQUIRY_VISIBILITY: 'TicketAttributes/SET_ADD_INQUIRY_VISIBILITY',
    SET_TICKET_ALL_TYPES: 'TicketAttributes/SET_TICKET_ALL_TYPES',
    SET_TICKET_ALL_CATEGORIES: 'TicketAttributes/SET_TICKET_ALL_CATEGORIES',
    SET_CURRENT_TICKET_TYPE: 'TicketAttributes/SET_CURRENT_TICKET_TYPE',
    SET_CURRENT_TICKET_CATEGORY: 'TicketAttributes/SET_CURRENT_TICKET_CATEGORY',
    SET_TICKET_ALL_INQUIRIES: 'TicketAttributes/SET_TICKET_ALL_INQUIRIES',
    SET_CURRENT_EDIT_CATEGORY: 'TicketAttributes/SET_CURRENT_EDIT_CATEGORY',
    SET_CURRENT_EDIT_INQUIRY: 'TicketAttributes/SET_CURRENT_EDIT_INQUIRY',
    SET_EDIT_CATEGORY_VISIBILITY: 'TicketAttributes/SET_EDIT_CATEGORY_VISIBILITY',
    SET_EDIT_INQUIRY_VISIBILITY: 'TicketAttributes/SET_EDIT_INQUIRY_VISIBILITY',
    SET_CURRENT_PROJECTS: 'TicketAttributes/SET_CURRENT_PROJECTS',
    SET_INQUIRY_ROLE_ASSIGNEE: 'TicketAttributes/SET_INQUIRY_ROLE_ASSIGNEE',
    SET_INQUIRY_ROLE_ASSIGNEE_USERS: 'TicketAttributes/SET_INQUIRY_ROLE_ASSIGNEE_USERS',
    RESET_TICKET_ATTRIBUTES_STORE_STATE: 'TicketAttributes/RESET_TICKET_ATTRIBUTES_STORE_STATE',

    // Waiting List
    SET_ALL_WAITING_LISTS: 'WaitingLists/SET_ALL_WAITING_LISTS',
    RESET_WAITING_LISTS: 'WaitingLists/RESET_WAITING_LISTS',
    SET_PREVIEW_APPLICATION_FORM_VISIBILITY: 'WaitingLists/SET_PREVIEW_APPLICATION_FORM_VISIBILITY',
    SET_CURRENT_PREVIEWED_APPLICATION: 'WaitingLists/SET_CURRENT_PREVIEWED_APPLICATION',
    SET_PREVIEWED_DOCUMENT: 'WaitingLists/SET_PREVIEWED_DOCUMENT',
    SET_PREVIEWED_DOCUMENT_ORIGINAL_NAME: 'WaitingLists/SET_PREVIEWED_DOCUMENT_ORIGINAL_NAME',
    SET_PREVIEWED_DOCUMENT_EXTENTION: 'WaitingLists/SET_PREVIEWED_DOCUMENT_EXTENTION',
    RESET_PREVIEW_DOCUMENT: 'WaitingLists/RESET_PREVIEW_DOCUMENT',
    SET_PREVIEWED_DOCUMENT_LOADING: 'WaitingLists/SET_PREVIEWED_DOCUMENT_LOADING',
    UPDATE_APPLICATION_STATE: 'WaitingLists/UPDATE_APPLICATION_STATE',
    SET_AVAILABLE_APARTMENTS: 'WaitingLists/SET_AVAILABLE_APARTMENTS',
    SET_AVAILABLE_APARTMENTS_VISIBILITY: 'WaitingLists/SET_AVAILABLE_APARTMENTS_VISIBILITY',
    SET_EXPIRATION_EMAIL_VISIBILITY: 'WaitingLists/SET_EXPIRATION_EMAIL_VISIBILITY',
    SET_SELECTED_APARTMENT_ID: 'WaitingLists/SET_SELECTED_APARTMENT_ID',
    SET_OAUTH_CLIENT_DATA: 'WaitingLists/SET_OAUTH_CLIENT_DATA',
    REMOVE_EDUCATIONAL_TAG_FROM_APPLICATION: 'WaitingLists/REMOVE_EDUCATIONAL_TAG_FROM_APPLICATION',
    ADD_EDUCATIONAL_TAG_TO_APPLICATION: 'WaitingLists/ADD_EDUCATIONAL_TAG_TO_APPLICATION',
    REMOVE_SOCIAL_TAG_FROM_APPLICATION: 'WaitingLists/REMOVE_SOCIAL_TAG_FROM_APPLICATION',
    ADD_SOCIAL_TAG_TO_APPLICATION: 'WaitingLists/ADD_SOCIAL_TAG_TO_APPLICATION',
    SET_APPLICATION_MASTER_DATA: 'WaitingLists/SET_APPLICATION_MASTER_DATA',
    REPLACE_APPLICATION: 'WaitingLists/REPLACE_APPLICATION',
    RESET_WAITING_LIST_STORE_STATE: 'WaitingLists/RESET_WAITING_LIST_STORE_STATE',

    // Presentation Flow
    SET_PRESENTATION_TYPE: 'PresentationFlows/SET_PRESENTATION_TYPE',
    SET_PRESENTATION_HEADER: 'PresentationFlows/SET_PRESENTATION_HEADER',
    SET_VACANT_UNITS: 'PresentationFlows/SET_VACANT_UNITS',
    SET_CURRENT_PROJECT: 'PresentationFlows/SET_CURRENT_PROJECT',
    SET_INPROGRESS_OFFERS: 'PresentationFlows/SET_INPROGRESS_OFFERS',
    SET_ADD_PRESENTATION_VISIBILITY: 'PresentationFlows/SET_ADD_PRESENTATION_VISIBILITY',
    SET_EDIT_PRESENTATION_VISIBILITY: 'PresentationFlows/SET_EDIT_PRESENTATION_VISIBILITY',
    SET_CURRENT_EDIT_PRESENTATION: 'PresentationFlows/SET_CURRENT_EDIT_PRESENTATION',
    SET_CURRENT_VACANT_UNIT_ADD: 'PresentationFlows/SET_CURRENT_VACANT_UNIT_ADD',
    SET_APPLICATIONS_FOR_PRESENTATION: 'PresentationFlows/SET_APPLICATIONS_FOR_PRESENTATION',
    SET_APPLICATION_MATCH: 'PresentationFlows/SET_APPLICATION_MATCH',
    SET_NOT_ACTIVE_IN_OTHER_OFFERS: 'PresentationFlows/SET_NOT_ACTIVE_IN_OTHER_OFFERS',
    SET_PREVIOUSLY_OFFER_UNIT: 'PresentationFlows/SET_PREVIOUSLY_OFFER_UNIT',
    SET_ASSIGN_TENANT_VISIBILITY: 'PresentationFlows/SET_ASSIGN_TENANT_VISIBILITY',
    SET_FINALIZE_PRESENTATION_VISIBILITY: 'PresentationFlows/SET_FINALIZE_PRESENTATION_VISIBILITY',
    SET_DEADLINE_OFFERS: 'PresentationFlows/SET_DEADLINE_OFFERS',
    RESET_ALL_MODAL_VISIBILITY: 'PresentationFlows/RESET_ALL_MODAL_VISIBILITY',
    SET_SENT_OFFERS: 'PresentationFlows/SET_SENT_OFFERS',
    SET_COMPLETED_OFFERS: 'PresentationFlows/SET_COMPLETED_OFFERS',
    SET_CLOSED_OFFERS: 'PresentationFlows/SET_CLOSED_OFFERS',
    SET_PRESENTATIONS_SEARCH_QUERY: 'PresentationFlows/SET_PRESENTATIONS_SEARCH_QUERY',
    RESET_PRESENTATION_FLOWS_STORE_STATE: 'PresentationFlows/RESET_PRESENTATION_FLOWS_STORE_STATE',

    // User Tickets
    SET_ALL_USER_TICKETS: 'UserTickets/SET_ALL_USER_TICKETS',
    SET_ADD_NEW_TICKET_TYPE_VISIBILITY: 'UserTickets/SET_ADD_NEW_TICKET_TYPE_VISIBILITY',
    SET_ADD_NEW_TICKET_ANSWER_VISIBILITY: 'UserTickets/SET_ADD_NEW_TICKET_ANSWER_VISIBILITY',
    SET_ADD_NEW_TICKET_THANKS_VISIBILITY: 'UserTickets/SET_ADD_NEW_TICKET_THANKS_VISIBILITY',
    SET_ADD_NEW_TICKET_THANKS_MODE: 'UserTickets/SET_ADD_NEW_TICKET_THANKS_MODE',
    SET_ADD_NEW_TICKET_INQUIRY_VISIBILITY: 'UserTickets/SET_ADD_NEW_TICKET_INQUIRY_VISIBILITY',
    SET_ADD_NEW_TICKET_CATEGORY_VISIBILITY: 'UserTickets/SET_ADD_NEW_TICKET_CATEGORY_VISIBILITY',
    SET_PREVIEW_TICKET_CONVERSATION_VISIBILITY: 'UserTickets/SET_PREVIEW_TICKET_CONVERSATION_VISIBILITY',
    SET_USER_TICKET_ALL_TYPES: 'UserTickets/SET_USER_TICKET_ALL_TYPES',
    SET_USER_CURRENT_TICKET_TYPE: 'UserTickets/SET_USER_CURRENT_TICKET_TYPE',
    SET_USER_TICKET_ALL_CATEGORIES: 'UserTickets/SET_USER_TICKET_ALL_CATEGORIES',
    SET_USER_CURRENT_TICKET_INQUIRY: 'UserTickets/SET_USER_CURRENT_TICKET_INQUIRY',
    SET_USER_CURRENT_TICKET_CATEGORY: 'UserTickets/SET_USER_CURRENT_TICKET_CATEGORY',
    SET_USER_TICKET_ALL_INQUIRIES: 'UserTickets/SET_USER_TICKET_ALL_INQUIRIES',
    SET_PREVIEW_TICKET_VISIBILITY: 'UserTickets/SET_PREVIEW_TICKET_VISIBILITY',
    SET_PREVIEW_TICKET_ATTACHMENTS_VISIBILITY: 'UserTickets/SET_PREVIEW_TICKET_ATTACHMENTS_VISIBILITY',
    SET_USER_CURRENT_TICKET: 'UserTickets/SET_USER_CURRENT_TICKET',
    SET_USER_TICKET_CONVERSATION: 'UserTickets/SET_USER_TICKET_CONVERSATION',
    SET_TICKET_SELECTED_PRIORITY: 'UserTickets/SET_TICKET_SELECTED_PRIORITY',
    SET_TICKET_SEARCH_QUERY: 'UserTickets/SET_TICKET_SEARCH_QUERY',
    UPDATE_SELECTED_TICKET_STATE: 'UserTickets/UPDATE_SELECTED_TICKET_STATE',
    UPDATE_SELECTED_TICKET_ASSIGNEE: 'UserTickets/UPDATE_SELECTED_TICKET_ASSIGNEE',
    RESET_TICKET_UNREAD_COUNT: 'UserTickets/RESET_TICKET_UNREAD_COUNT',
    UPDATE_TICKET_UNREAD_MESSAGES: 'UserTickets/UPDATE_TICKET_UNREAD_MESSAGES',
    TICKET_PRIORITY_DROPDOWN_VISIBILITY: 'UserTickets/TICKET_PRIORITY_DROPDOWN_VISIBILITY',
    TICKET_REMAIN_WATCHER_VISIBILITY: 'UserTickets/TICKET_REMAIN_WATCHER_VISIBILITY',
    SET_TICKET_CREATE_FORM_OVERLAY_VISIBILITY: 'UserTickets/SET_TICKET_CREATE_FORM_OVERLAY_VISIBILITY',
    SET_USER_TICKET_PRIORITY: 'UserTickets/SET_USER_TICKET_PRIORITY',
    ADD_SOCKET_INIT_USER_TICKET_ID: 'UserTickets/ADD_SOCKET_INIT_USER_TICKET_ID',
    EXECUTE_USER_TICKET_UPDATE: 'UserTickets/EXECUTE_USER_TICKET_UPDATE',
    PUSH_TO_USER_TICKET_CONVERSATION: 'UserTickets/PUSH_TO_USER_TICKET_CONVERSATION',
    REMOVE_USER_TICKET_CONVERSATION_MESSAGE: 'UserTickets/REMOVE_USER_TICKET_CONVERSATION_MESSAGE',
    SET_ACTIVE_TICKET_IMAGES: 'UserTickets/SET_ACTIVE_TICKET_IMAGES',
    SET_ACTIVE_STAFF_TICKETS_ORDER: 'UserTickets/SET_ACTIVE_STAFF_TICKETS_ORDER',
    SET_ACTIVE_STAFF_TICKETS_TYPE: 'UserTickets/SET_ACTIVE_STAFF_TICKETS_TYPE',
    ADD_NEW_USER_TICKET: 'UserTickets/ADD_NEW_USER_TICKET',
    MAKE_USER_TICKET_RESPONDED: 'UserTickets/MAKE_USER_TICKET_RESPONDED',
    RESET_USER_TICKETS_STORE_STATE: 'UserTickets/RESET_USER_TICKETS_STORE_STATE',

    // Staff Properties
    SET_STAFF_PROPERTIES: 'StaffProperties/SET_STAFF_PROPERTIES',
    SET_STAFF_CURRENT_PROPERTY: 'StaffProperties/SET_STAFF_CURRENT_PROPERTY',
    SET_STAFF_PROPERTY_ICON_LINK: 'StaffProperties/SET_STAFF_PROPERTY_ICON_LINK',
    SET_STAFF_CHAT_BACK_LINK: 'StaffProperties/SET_STAFF_CHAT_BACK_LINK',
    SET_INDEX_PAGES_KEYBOARD_VISIBILITY: 'StaffProperties/SET_INDEX_PAGES_KEYBOARD_VISIBILITY',
    RESET_STAFF_PROPERTIES_STORE_STATE: 'StaffProperties/RESET_STAFF_PROPERTIES_STORE_STATE',

    // Integrations
    SET_INTEGRATION_TYPES: 'Integrations/SET_INTEGRATION_TYPES',
    SET_INTEGRATION_ALL_CURRENTS: 'Integrations/SET_INTEGRATION_ALL_CURRENTS',
    SET_INTEGRATION_CURRENT_CORPORATION: 'Integrations/SET_INTEGRATION_CURRENT_CORPORATION',
    SET_ADD_INTEGRATION_VISIBILITY: 'Integrations/SET_ADD_INTEGRATION_VISIBILITY',
    SET_PREVIEW_INTEGRATION_VISIBILITY: 'Integrations/SET_PREVIEW_INTEGRATION_VISIBILITY',
    SET_INTEGRATION_UPLOAD_STATUS: 'Integrations/SET_INTEGRATION_UPLOAD_STATUS',
    SET_INTEGRATION_UPLOAD_PERCENTAGE: 'Integrations/SET_INTEGRATION_UPLOAD_PERCENTAGE',
    SET_CURRENT_INTEGRATION_SINGLE_DATA_OUTPUT: 'Integrations/SET_CURRENT_INTEGRATION_SINGLE_DATA_OUTPUT',
    SET_CURRENT_INTEGRATION_OUTPUT_OVERLAY_VISIBILITY: 'Integrations/SET_CURRENT_INTEGRATION_OUTPUT_OVERLAY_VISIBILITY',
    SET_ALL_INTEGRATIONS: 'Integrations/SET_ALL_INTEGRATIONS',
    SET_CURRENT_INTEGRATION: 'Integrations/SET_CURRENT_INTEGRATION',
    SET_CURRENT_INTEGRATION_DATA: 'Integrations/SET_CURRENT_INTEGRATION_DATA',
    SET_INTEGRATION_SEARCH_OPTION: 'Integrations/SET_INTEGRATION_SEARCH_OPTION',
    UPDATE_INTEGRATION_DATA: 'Integrations/UPDATE_INTEGRATION_DATA',
    RESET_INTEGRATIONS: 'Integrations/RESET_INTEGRATIONS',
    RESET_INTEGRATIONS_STORE_STATE: 'Integrations/RESET_INTEGRATIONS_STORE_STATE',

    // User profile
    SET_PREVIEW_USER_PROFILE_VISIBILITY: 'UserProfiles/SET_PREVIEW_USER_PROFILE_VISIBILITY',
    SET_USER_PROFILE_SEARCH_OPTION: 'UserProfiles/SET_USER_PROFILE_SEARCH_OPTION',
    SET_ALL_USER_PROFILES: 'UserProfiles/SET_ALL_USER_PROFILES',
    SET_CURRENT_USER_PROFILE: 'UserProfiles/SET_CURRENT_USER_PROFILE',
    SET_USER_PROFILES_STORE_STATE: 'UserProfiles/SET_USER_PROFILES_STORE_STATE',

    // Confirm popup
    SET_CONFIRM_POPUP_DATA: 'ConfirmPopup/SET_CONFIRM_POPUP_DATA',
    RESET_CONFIRM_POPUP_DATA: 'ConfirmPopup/RESET_CONFIRM_POPUP_DATA',
    RESET_CONFIRM_POPUP_STORE_STATE: 'ConfirmPopup/RESET_CONFIRM_POPUP_STORE_STATE',

    // Event logs
    SET_EVENT_LOGS: 'EventLogs/SET_EVENT_LOGS',
    SET_EVENT_LOGS_UNSEEN: 'EventLogs/SET_EVENT_LOGS_UNSEEN',
    SET_EVENT_LOGS_UNSEEN_COUNT: 'EventLogs/SET_EVENT_LOGS_UNSEEN_COUNT',
    SET_EVENT_LOG_SEEN: 'EventLogs/SET_EVENT_LOG_SEEN',
    SET_EVENT_LOGS_SEARCH_OPTION: 'EventLogs/SET_EVENT_LOGS_SEARCH_OPTION',
    DECREASE_EVENT_LOGS_UNSEEN_COUNT: 'EventLogs/DECREASE_EVENT_LOGS_UNSEEN_COUNT',
    UPDATE_EVENT_LOGS: 'EventLogs/UPDATE_EVENT_LOGS',
    RESET_UNSEEN_EVENT_LOGS: 'EventLogs/RESET_UNSEEN_EVENT_LOGS',
    RESET_EVENT_LOGS_STORE_STATE: 'EventLogs/RESET_EVENT_LOGS_STORE_STATE',

    // Shared Facilities
    SET_FACILITY_DETAILS_OVERLAY_VISIBILITY: 'SharedFacilities/SET_FACILITY_DETAILS_OVERLAY_VISIBILITY',
    SET_BOOK_FACILITY_OVERLAY_VISIBILITY: 'SharedFacilities/SET_BOOK_FACILITY_OVERLAY_VISIBILITY',
    SET_BOOKED_FACILITY_OVERLAY_VISIBILITY: 'SharedFacilities/SET_BOOKED_FACILITY_OVERLAY_VISIBILITY',
    SET_BOOKED_FACILITY_OVERLAY_MODE: 'SharedFacilities/SET_BOOKED_FACILITY_OVERLAY_MODE',
    SET_BOOK_FACILITY_TIME_OVERLAY_VISIBILITY: 'SharedFacilities/SET_BOOK_FACILITY_TIME_OVERLAY_VISIBILITY',
    SET_BOOK_FACILITY_DATE_OVERLAY_VISIBILITY: 'SharedFacilities/SET_BOOK_FACILITY_DATE_OVERLAY_VISIBILITY',
    SET_FACILITY_BOOKING_TIME: 'SharedFacilities/SET_FACILITY_BOOKING_TIME',
    RESET_FACILITY_BOOKING_TIME: 'SharedFacilities/RESET_FACILITY_BOOKING_TIME',
    SET_FACILITY_BOOKING_DATE: 'SharedFacilities/SET_FACILITY_BOOKING_DATE',
    RESET_FACILITY_BOOKING_DATE: 'SharedFacilities/RESET_FACILITY_BOOKING_DATE',
    SET_FACILITY_PAGE_DEFAULT_TAB: 'SharedFacilities/SET_FACILITY_PAGE_DEFAULT_TAB',
    SET_FACILITY_FORM_MODE: 'SharedFacilities/SET_FACILITY_FORM_MODE',
    SET_ACTIVE_ADMIN_FACILITY: 'SharedFacilities/SET_ACTIVE_ADMIN_FACILITY',
    SET_ADMIN_CALENDAR_SELECTED_DATE: 'SharedFacilities/SET_ADMIN_CALENDAR_SELECTED_DATE',
    SET_PROJECT_ALL_FACILITIES: 'SharedFacilities/SET_PROJECT_ALL_FACILITIES',
    SET_ACTIVE_ADMIN_FACILITY_PHOTOS: 'SharedFacilities/SET_ACTIVE_ADMIN_FACILITY_PHOTOS',
    SET_ADMIN_ACTIVE_FACILITY_BOOKINGS: 'SharedFacilities/SET_ADMIN_ACTIVE_FACILITY_BOOKINGS',
    SET_USER_SHARED_FACILITIES: 'SharedFacilities/SET_USER_SHARED_FACILITIES',
    SET_USER_FACILITIES_BOOKINGS: 'SharedFacilities/SET_USER_FACILITIES_BOOKINGS',
    RESET_USER_SHARED_FACILITIES: 'SharedFacilities/RESET_USER_SHARED_FACILITIES',
    RESET_USER_FACILITIES_BOOKINGS: 'SharedFacilities/RESET_USER_FACILITIES_BOOKINGS',
    SET_USER_SELECTED_BOOKING: 'SharedFacilities/SET_USER_SELECTED_BOOKING',
    SET_USER_SELECTED_FACILITY: 'SharedFacilities/SET_USER_SELECTED_FACILITY',
    DELETE_USER_BOOKING: 'SharedFacilities/DELETE_USER_BOOKING',
    SET_USER_BOOKING_REQUESTS_STATUS: 'SharedFacilities/SET_USER_BOOKING_REQUESTS_STATUS',
    SET_SHARED_FACILITIES_PHOTOS: 'SharedFacilities/SET_SHARED_FACILITIES_PHOTOS',
    RESET_SHARED_FACILITIES_PHOTOS: 'SharedFacilities/RESET_SHARED_FACILITIES_PHOTOS',
    SET_ADMIN_ACTIVE_FACILITY_SELECTED_DATE_BOOKINGS: 'SharedFacilities/SET_ADMIN_ACTIVE_FACILITY_SELECTED_DATE_BOOKINGS',
    REMOVE_ADMIN_ACTIVE_FACILITY: 'SharedFacilities/REMOVE_ADMIN_ACTIVE_FACILITY',
    RESET_ADMIN_ACTIVE_FACILITY: 'SharedFacilities/RESET_ADMIN_ACTIVE_FACILITY',
    SET_ALL_FACILITY_TYPES: 'SharedFacilities/SET_ALL_FACILITY_TYPES',
    SET_ADD_FACILITY_ID: 'SharedFacilities/SET_ADD_FACILITY_ID',
    RESET_SHARED_FACILITY_UNAVAILABILITY: 'SharedFacilities/RESET_SHARED_FACILITY_UNAVAILABILITY',
    SET_SHARED_FACILITIES_UNAVAILABILITY: 'SharedFacilities/SET_SHARED_FACILITIES_UNAVAILABILITY',
    SET_FACILITY_FOR_UPDATE: 'SharedFacilities/SET_FACILITY_FOR_UPDATE',
    REMOVE_FACILITY_FOR_UPDATE: 'SharedFacilities/REMOVE_FACILITY_FOR_UPDATE',
    SET_FACILITY_PHOTOS_FOR_UPDATE: 'SharedFacilities/SET_FACILITY_PHOTOS_FOR_UPDATE',
    REMOVE_UPDATED_FACILITY_PHOTO: 'SharedFacilities/REMOVE_UPDATED_FACILITY_PHOTO',
    REMOVE_FROM_ACTIVE_BOOKINGS: 'SharedFacilities/REMOVE_FROM_ACTIVE_BOOKINGS',
    SET_ACTIVE_ADMIN_FACILITY_MASK: 'SharedFacilities/SET_ACTIVE_ADMIN_FACILITY_MASK',
    UPDATE_MAX_BOOKABLE_BLOCKS: 'SharedFacilities/UPDATE_MAX_BOOKABLE_BLOCKS',
    UPDATE_MAX_BOOKINGS_PER_BLOCK: 'SharedFacilities/UPDATE_MAX_BOOKINGS_PER_BLOCK',
    UPDATE_MIN_BOOKABLE_BLOCKS: 'SharedFacilities/UPDATE_MIN_BOOKABLE_BLOCKS',
    UPDATE_PRICE: 'SharedFacilities/UPDATE_PRICE',
    RESET_SHARED_FACILITIES_STORE_STATE: 'SharedFacilities/RESET_SHARED_FACILITIES_STORE_STATE',
    SET_FACILITY_WATCHERS: 'SharedFacilities/SET_FACILITY_WATCHERS',
    SET_FACILITY_ALL_WATCHERS: 'SharedFacilities/SET_FACILITY_ALL_WATCHERS',
    SET_FACILITY_BOOKING_DURATION: 'SharedFacilities/SET_FACILITY_BOOKING_DURATION',
    SET_FACILITY_BOOKING_COST: 'SharedFacilities/SET_FACILITY_BOOKING_COST',

    // Tags
    SET_TAGS: 'Tags/SET_TAGS',
    SET_SOCIAL_TAG: 'Tags/SET_SOCIAL_TAG',
    SET_EDUCATIONAL_TAG: 'Tags/SET_EDUCATIONAL_TAG',
    RESET_TAGS_STORE_STATE: 'Tags/RESET_TAGS_STORE_STATE',

    // Categories
    SET_DOCUMENT_CATEGORIES: 'Categories/SET_DOCUMENT_CATEGORIES',
    SET_ACTIVE_CATEGORY: 'Categories/SET_ACTIVE_CATEGORY',
    SET_CREATE_DOCUMENT_WITH_CATEGORY: 'Categories/SET_CREATE_DOCUMENT_WITH_CATEGORY',
    RESET_CATEGORIES_STORE_STATE: 'Categories/RESET_CATEGORIES_STORE_STATE',

    // Roles and permissions
    SET_PERMISSION_ROLES: 'RolesAndPermissions/SET_PERMISSION_ROLES',
    SET_PERMISSION_FEATURES: 'RolesAndPermissions/SET_PERMISSION_FEATURES',
    SET_TOGGLED_PERMISSION_ROLE_FEATURE: 'RolesAndPermissions/SET_TOGGLED_PERMISSION_ROLE_FEATURE',
    ADD_TO_ROLE_LIST: 'RolesAndPermissions/ADD_TO_ROLE_LIST',
    SET_CURRENT_EDIT_ROLE: 'RolesAndPermissions/SET_CURRENT_EDIT_ROLE',
    UPDATE_CURRENT_ROLE: 'RolesAndPermissions/UPDATE_CURRENT_ROLE',
    RESET_ROLES_AND_PERMISSIONS: 'RolesAndPermissions/RESET_ROLES_AND_PERMISSIONS',

    // Unit Finance
    SET_CHARGES_COMPONENT: 'UnitFinance/SET_CHARGES_COMPONENT',
    SET_REFUND_COMPONENT: 'UnitFinance/SET_REFUND_COMPONENT',
    SET_FIXED_CHARGES_COMPONENT: 'UnitFinance/SET_FIXED_CHARGES_COMPONENT',
    SET_CONSUMPTION_ACCOUNTS_COMPONENT: 'UnitFinance/SET_CONSUMPTION_ACCOUNTS_COMPONENT',
    SET_CHARGES_FORM_MODE: 'UnitFinance/SET_CHARGES_FORM_MODE',
    SET_CHARGES_TABLE_CURRENT_TAB: 'UnitFinance/SET_CHARGES_TABLE_CURRENT_TAB',
    SET_CREDITS_FINANCE_DATA: 'UnitFinance/SET_CREDITS_FINANCE_DATA',
    SET_PERIODICAL_CHARGES_FINANCE_DATA: 'UnitFinance/SET_PERIODICAL_CHARGES_FINANCE_DATA',
    SET_ACTIVE_PERIODICAL_CHARGE_FINANCE_DATA: 'UnitFinance/SET_ACTIVE_PERIODICAL_CHARGE_FINANCE_DATA',
    SET_ONE_TIME_CHARGES_FINANCE_DATA: 'UnitFinance/SET_ONE_TIME_CHARGES_FINANCE_DATA',
    SET_REFUNDS_FINANCE_DATA: 'UnitFinance/SET_REFUNDS_FINANCE_DATA',
    SET_FIXED_CHARGES_FINANCE_DATA: 'UnitFinance/SET_FIXED_CHARGES_FINANCE_DATA',
    SET_CONSUMPTION_ACCOUNTS_FINANCE_DATA: 'UnitFinance/SET_CONSUMPTION_ACCOUNTS_FINANCE_DATA',
    ADD_FIXED_CHARGE_DATA: 'UnitFinance/ADD_FIXED_CHARGE_DATA',
    ADD_REFUND_CHARGE_DATA: 'UnitFinance/ADD_REFUND_CHARGE_DATA',
    ADD_PERIODICAL_CHARGE_DATA: 'UnitFinance/ADD_PERIODICAL_CHARGE_DATA',
    ADD_ONE_TIME_CHARGE_DATA: 'UnitFinance/ADD_ONE_TIME_CHARGE_DATA',
    REMOVE_PERIODICAL_CHARGE_DATA: 'UnitFinance/REMOVE_PERIODICAL_CHARGE_DATA',
    REMOVE_ONE_TIME_CHARGE: 'UnitFinance/REMOVE_ONE_TIME_CHARGE',
    REMOVE_ONE_TIME_CHARGE_DATA: 'UnitFinance/REMOVE_ONE_TIME_CHARGE_DATA',
    ADD_CONSUMPTION_ACCOUNT_DATA: 'UnitFinance/ADD_CONSUMPTION_ACCOUNT_DATA',
    SET_PAUSE_AUTOMATIC_CHARGING_OVERLAY_VISIBILITY: 'UnitFinance/SET_PAUSE_AUTOMATIC_CHARGING_OVERLAY_VISIBILITY',
    SET_START_AUTOMATIC_CHARGING_OVERLAY_VISIBILITY: 'UnitFinance/SET_START_AUTOMATIC_CHARGING_OVERLAY_VISIBILITY',
    SET_SELECTED_AUTOMATIC_CHARGING: 'UnitFinance/SET_SELECTED_AUTOMATIC_CHARGING',
    SET_PERIODICAL_CHARGE_PAUSE_STATUS: 'UnitFinance/SET_PERIODICAL_CHARGE_PAUSE_STATUS',
    SET_PERIODICAL_CHARGE_START_STATUS: 'UnitFinance/SET_PERIODICAL_CHARGE_START_STATUS',
    SET_PERIODICAL_CHARGE_DATA: 'UnitFinance/SET_PERIODICAL_CHARGE_DATA',
    SET_AUTOMATIC_RENT_INCREASE_OVERLAY_VISIBILITY: 'UnitFinance/SET_AUTOMATIC_RENT_INCREASE_OVERLAY_VISIBILITY',
    SET_INTERVALS: 'UnitFinance/SET_INTERVALS',
    SET_PAYMENT_ORDER_LINE_TYPES: 'UnitFinance/SET_PAYMENT_ORDER_LINE_TYPES',
    SET_UNIT_ARREARS: 'UnitFinance/SET_UNIT_ARREARS',
    UPDATE_UNIT_ARREAR: 'UnitFinance/UPDATE_UNIT_ARREAR',
    SET_CREDITS_ORDER_LINES_DATA: 'UnitFinance/SET_CREDITS_ORDER_LINES_DATA',
    SET_BALANCE_ACCOUNT_DATA: 'UnitFinance/SET_BALANCE_ACCOUNT_DATA',
    SET_CURRENCIES: 'UnitFinance/SET_CURRENCIES',
    SET_PAYMENT_PROVIDERS: 'UnitFinance/SET_PAYMENT_PROVIDERS',
    SET_CREATE_DEPOSIT_POPUP_VISIBILITY: 'CreateDepositForm/SET_CREATE_DEPOSIT_POPUP_VISIBILITY',
    SET_CREATE_REFUND_POPUP_VISIBILITY: 'CreateRefundForm/SET_CREATE_REFUND_POPUP_VISIBILITY',
    SET_UNIT_ORDERS: 'UnitFinance/SET_UNIT_ORDERS',
    SET_UNIT_REFUNDABLE_ORDERS: 'UnitFinance/SET_UNIT_REFUNDABLE_ORDERS',

    // Unpaid Payments
    SET_UNPAID_PAYMENTS_DATA: 'UnpaidPayments/SET_UNPAID_PAYMENTS_DATA',
    SET_CORPORATION_UNPAID_TRANSACTIONS_DATA: 'CorpTransactions/SET_CORPORATION_UNPAID_TRANSACTIONS_DATA',
    SET_SHOW_PAYMENT_PAGE_STATUS: 'OrderDetails/SET_SHOW_PAYMENT_PAGE_STATUS',

    // Credit Cards
    SET_USER_CREDIT_CARDS: 'CreditCards/SET_USER_CREDIT_CARDS',
    REMOVE_CREDIT_CARD: 'CreditCards/REMOVE_CREDIT_CARD',
    ADD_CREDIT_CARD: 'CreditCards/ADD_CREDIT_CARD',
    SET_ADD_NEW_CARD_FORM_VISIBILITY: 'CreditCards/SET_ADD_NEW_CARD_FORM_VISIBILITY',
    SET_DEFAULT_PAYMENT_METHOD: 'CreditCards/SET_DEFAULT_PAYMENT_METHOD',
    SET_ACTIVE_CREDIT_CARD: 'CreditCards/SET_ACTIVE_CREDIT_CARD',

    // User Wallet
    SET_USER_TRANSACTIONS: 'UserWallet/SET_USER_TRANSACTIONS',
    UPDATE_ACTIVE_TRANSACTION: 'UserWallet/UPDATE_ACTIVE_TRANSACTION',
    SET_CHOOSE_PAYMENT_METHOD_BLOCK_VISIBILITY: 'UserWallet/SET_CHOOSE_PAYMENT_METHOD_BLOCK_VISIBILITY',
    SET_PAY_FOR_ORDER_MODAL_VISIBILITY: 'UserWallet/SET_PAY_FOR_ORDER_MODAL_VISIBILITY',
    SET_SHOW_WALLET_BLOCK_VISIBILITY: 'UserWallet/SET_SHOW_WALLET_BLOCK_VISIBILITY',
    SET_SHOW_CREDIT_CARDS_BLOCK_VISIBILITY: 'UserWallet/SET_SHOW_CREDIT_CARDS_BLOCK_VISIBILITY',
    SET_SHOW_TRANSACTIONS_BLOCK_VISIBILITY: 'UserWallet/SET_SHOW_TRANSACTIONS_BLOCK_VISIBILITY',
    SET_ORDER_PAY_SUCCESS_MODAL_VISIBILITY: 'UserWallet/SET_ORDER_PAY_SUCCESS_MODAL_VISIBILITY',
    SET_ORDER_PAY_FAILURE_MODAL_VISIBILITY: 'UserWallet/SET_ORDER_PAY_FAILURE_MODAL_VISIBILITY',

    // CORPORATION FINANCES
    SET_CORPORATION_STRIPE_CONNECTION_STATUS: 'FinanceControl/SET_CORPORATION_STRIPE_CONNECTION_STATUS',

    // USER FINANCES
    SET_UPCOMING_PAYMENTS_DATA: 'UserUpcomingPayments/SET_UPCOMING_PAYMENTS_DATA',
    SET_ORDER_DETAILS: 'UserUpcomingPayments/SET_ORDER_DETAILS',
    SET_STRIPE_PUBLIC_KEY: 'UserUpcomingPayments/SET_STRIPE_PUBLIC_KEY',

    // Property Notes
    RESET_PROPERTY_NOTES_STATE: 'PropertyNotes/RESET_PROPERTY_NOTES_STATE',
    ADD_PROPERTY_NOTES: 'PropertyNotes/ADD_PROPERTY_NOTES',
    ADD_PROPERTY_NOTE: 'PropertyNotes/ADD_PROPERTY_NOTE',
    UPDATE_PROPERTY_NOTE: 'PropertyNotes/UPDATE_PROPERTY_NOTE',
    REMOVE_UNIT_NOTE: 'PropertyNotes/REMOVE_UNIT_NOTE',
    SET_ACTIVE_NOTE: 'PropertyNotes/SET_ACTIVE_NOTE',
    SET_EDIT_NOTE_OVERLAY_VISIBILITY: 'PropertyNotes/SET_EDIT_NOTE_OVERLAY_VISIBILITY',
    SET_NOTE_PREVIEW: 'PropertyNotes/SET_NOTE_PREVIEW',
    SET_PREVIEW_IMAGE_VISIBILITY: 'PropertyNotes/SET_PREVIEW_IMAGE_VISIBILITY',

    // Likes
    RESET_LIKES_STORE_STATE: 'Likes/RESET_LIKES_STORE_STATE',
    SET_LIKE_REQUEST_IS_ACTIVE: 'Likes/SET_LIKE_REQUEST_IS_ACTIVE',

    // Grouping
    SET_ALL_GROUPINGS: 'Groupings/SET_ALL_GROUPINGS',
    SET_CURRENT_GROUPING: 'Groupings/SET_CURRENT_GROUPING',
    SET_CURRENT_GROUPING_UNITS: 'Groupings/SET_CURRENT_GROUPING_UNITS',
    SET_CURRENT_GROUPING_RESIDENTS: 'Groupings/SET_CURRENT_GROUPING_RESIDENTS',
    SET_GROUPING_TYPES: 'Groupings/SET_GROUPING_TYPES',
    REMOVE_GROUPING: 'Groupings/REMOVE_GROUPING',
    SET_UNIT_GROUPINGS: 'Groupings/SET_UNIT_GROUPINGS',
    RESET_UNIT_GROUPINGS: 'Groupings/RESET_UNIT_GROUPINGS',
    RESET_ALL_UNIT_GROUPINGS: 'Groupings/RESET_ALL_UNIT_GROUPINGS',
    REMOVE_UNIT_FROM_GROUPING_LIST: 'Groupings/REMOVE_UNIT_FROM_GROUPING_LIST',
    RESET_GROUPINGS_STORE_STATE: 'Groupings/RESET_GROUPINGS_STORE_STATE',

    // Table Config
    SET_TABLE_CONFIG: 'TableConfigs/SET_TABLE_CONFIG',
    RESET_TABLE_CONFIG_STORE_STATE: 'TableConfigs/RESET_TABLE_CONFIG_STORE_STATE',
    SET_SELECTED_VIEW: 'TableConfigs/SET_SELECTED_VIEW',
    SET_SELECTED_VIEW_CONFIG: 'TableConfigs/SET_SELECTED_VIEW_CONFIG',
    SET_VIEW_OPTION_LIST: 'TableConfigs/SET_VIEW_OPTION_LIST',
    UPDATE_VIEW_OPTION: 'TableConfigs/UPDATE_VIEW_OPTION',
    REMOVE_VIEW_OPTION: 'TableConfigs/REMOVE_VIEW_OPTION',
    ADD_VIEW_OPTION: 'TableConfigs/ADD_VIEW_OPTION',
    SET_TABLE_VIEW_DEFAULT_VALUE: 'TableConfigs/SET_TABLE_VIEW_DEFAULT_VALUE',

    // Unit Grouping Charts
    SET_UNIT_GROUP_TENANTS_DEMOGRAPHIC_DATA: 'UnitGroupingCharts/SET_UNIT_GROUP_TENANTS_DEMOGRAPHIC_DATA',
    RESET_UNIT_GROUP_TENANTS_DEMOGRAPHIC_DATA: 'UnitGroupingCharts/RESET_UNIT_GROUP_TENANTS_DEMOGRAPHIC_DATA',
    SET_TENANTS_DEMOGRAPHIC_FLAYOUT_VISIBILITY: 'UnitGroupingCharts/SET_TENANTS_DEMOGRAPHIC_FLAYOUT_VISIBILITY',
    RESET_UNIT_GROUPING_CHARTS_STORE_STATE: 'UnitGroupingCharts/RESET_UNIT_GROUPING_CHARTS_STORE_STATE',

    // Template Renderer
    TEMPLATE_RENDERER_OVERLAY_VISIBILITY: 'TemplateRenderer/TEMPLATE_RENDERER_OVERLAY_VISIBILITY',
    SET_TEMPLATE_RENDERER: 'TemplateRenderer/SET_TEMPLATE_RENDERER',
    RESET_TEMPLATE_RENDERER_STORE_STATE: 'TemplateRenderer/RESET_TEMPLATE_RENDERER_STORE_STATE',

    // Home Assistant
    SET_HOME_ASSISTANT_VISIBILITY: 'HomeAssistant/SET_HOME_ASSISTANT_VISIBILITY',
    SET_HOME_ASSISTANT_CURRENT_VIEW: 'HomeAssistant/SET_HOME_ASSISTANT_CURRENT_VIEW',
    SET_HOME_ASSISTANT_PREV_VIEW: 'HomeAssistant/SET_HOME_ASSISTANT_PREV_VIEW',
    SET_ACTIVE_HOME_ASSISTANT_TYPE: 'HomeAssistant/SET_ACTIVE_HOME_ASSISTANT_TYPE',
    SET_ACTIVE_HOME_ASSISTANT_CATEGORY: 'HomeAssistant/SET_ACTIVE_HOME_ASSISTANT_CATEGORY',
    SET_ACTIVE_HOME_ASSISTANT_INQUIRY: 'HomeAssistant/SET_ACTIVE_HOME_ASSISTANT_INQUIRY',
    SET_HOME_ASSISTANT_SEARCH_QUERY_VALUE: 'HomeAssistant/SET_HOME_ASSISTANT_SEARCH_QUERY_VALUE',
    RESET_HOME_ASSISTANT_STORE_STATE: 'HomeAssistant/RESET_HOME_ASSISTANT_STORE_STATE',

    // Report Issue
    SET_REPORT_ISSUE_OVERLAY_VISIBILITY: 'IssueReport/SET_REPORT_ISSUE_OVERLAY_VISIBILITY',
    RESET_ISSUE_REPORT_STORE_STATE: 'IssueReport/RESET_ISSUE_REPORT_STORE_STATE',

    // User Tickets Attributes
    SET_INQUIRY_TYPES: 'UserTicketsAttributes/SET_INQUIRY_TYPES',
    SET_INQUIRY_CATEGORIES: 'UserTicketsAttributes/SET_INQUIRY_CATEGORIES',
    SET_INQUIRIES: 'UserTicketsAttributes/SET_INQUIRIES',
    SET_INQUIRY_ANSWER: 'UserTicketsAttributes/SET_INQUIRY_ANSWER',
    RESET_INQUIRY_ANSWER: 'UserTicketsAttributes/RESET_INQUIRY_ANSWER',
    RESET_USER_TICKETS_ATTRIBUTES_STORE_STATE: 'UserTicketsAttributes/RESET_USER_TICKETS_ATTRIBUTES_STORE_STATE',

    // Loading
    SET_LOADING_STATUS: 'Loading/SET_LOADING_STATUS',
    SET_LOADING_LOCK_STATUS: 'Loading/SET_LOADING_LOCK_STATUS',
    TOGGLE_CANCELLATION_TOKEN: 'Loading/TOGGLE_CANCELLATION_TOKEN',
    CANCEL_REQUEST: 'Loading/CANCEL_REQUEST',
    RESET_LOADING_STORE_STATE: 'Loading/RESET_LOADING_STORE_STATE',

    // File Upload
    SET_FILE_UPLOAD_PROGRESS: 'FileUpload/SET_FILE_UPLOAD_PROGRESS',
    INIT_FILE_UPLOAD_PROGRESS: 'FileUpload/INIT_FILE_UPLOAD_PROGRESS',
    RESET_FILE_UPLOAD_PROGRESS: 'FileUpload/RESET_FILE_UPLOAD_PROGRESS',
    RESET_FILE_UPLOAD_STORE_STATE: 'FileUpload/RESET_FILE_UPLOAD_STORE_STATE',

    // Comments
    SET_COMMENTS_OVERLAY_VISIBILITY: 'Comments/SET_COMMENTS_OVERLAY_VISIBILITY',
    SET_COMMENTS: 'Comments/SET_COMMENTS',
    RESET_COMMENTS: 'Comments/RESET_COMMENTS',
    ADD_NEW_COMMENT: 'Comments/ADD_NEW_COMMENT',
    DELETE_COMMENT: 'Comments/DELETE_COMMENT',
    MARK_COMMENTS_AS_SEEN: 'Comments/MARK_COMMENTS_AS_SEEN',
    RESET_COMMENTS_STORE_STATE: 'Comments/RESET_COMMENTS_STORE_STATE',
    INCREASE_COMMENT_COUNT: 'TenantNotifications/INCREASE_COMMENT_COUNT',
    DECREASE_COMMENT_COUNT: 'TenantNotifications/DECREASE_COMMENT_COUNT',

    // Identities
    SET_IDENTITIES: 'Identities/SET_IDENTITIES',
    RESET_IDENTITIES_STORE_STATE: 'Identities/RESET_IDENTITIES_STORE_STATE',
    SET_USER_IDENTITY: 'Identities/SET_USER_IDENTITY',
    SET_IDENTITIES_NOTIFICATIONS: 'Identities/SET_IDENTITIES_NOTIFICATIONS',
    UPDATE_IDENTITY_NOTIFICATIONS: 'Identities/UPDATE_IDENTITY_NOTIFICATIONS',
    SET_EULA_ACCEPTED_AT: 'Identities/SET_EULA_ACCEPTED_AT',

    // Overlays
    SET_OVERLAY_VISIBILITY: 'Overlays/SET_OVERLAY_VISIBILITY',
    RESET_OVERLAYS_STORE_STATE: 'Overlays/RESET_OVERLAYS_STORE_STATE',

    // Global Overlay
    RESET_GLOBAL_OVERLAY_STORE_STATE: 'GlobalOverlay/RESET_GLOBAL_OVERLAY_STORE_STATE',
    SET_GLOBAL_OVERLAY_VISIBILITY_STATUS: 'GlobalOverlay/SET_GLOBAL_OVERLAY_VISIBILITY',
    SET_GLOBAL_OVERLAY_CONFIG: 'GlobalOverlay/SET_GLOBAL_OVERLAY_CONFIG',

    // Scroll
    RESET_SCROLL_STORE_STATE: 'Scroll/RESET_SCROLL_STORE_STATE',
    SET_STAFF_APP_PAGE_SCROLL_POSITION: 'Scroll/SET_STAFF_APP_PAGE_SCROLL_POSITION',
    SET_TENANT_APP_PAGE_SCROLL_POSITION: 'Scroll/SET_TENANT_APP_PAGE_SCROLL_POSITION',

    // Abuse
    SET_ABUSE_ACTIONS_DICTIONARY: 'Abuse/SET_ABUSE_ACTIONS_DICTIONARY',
    RESET_ABUSE_STORE_STATE: 'Abuse/RESET_ABUSE_STORE_STATE',
};

export const OAuth = {
    AUTH_ENDPOINT: 'https://127.0.0.1/oauth/token',
    USER_ENDPOINT: 'https://127.0.0.1/api/user',
    CLIENT_ID: '2',
    CLIENT_SECRET: 'SVNR3D9ItGSQnTPTjCXt1jOO35XuKkSjB8zXrO3n',
};

export const Endpoints = {
    Neckbeard: {
        MISSING_TRANSLATIONS: `${apiUrl}/api/system/translations`,
        GET_ALL_CORPORATIONS: `${apiUrl}/api/system/tools/corporations`,
        GET_ALL_PROJECTS: `${apiUrl}/api/system/tools/projects`,
        COPY_KNOWLEDGE_BASE: `${apiUrl}/api/system/tools/knowledge-base/copy`,
        IMPORT_KNOWLEDGE_BASE: `${apiUrl}/api/system/tools/knowledge-base/import`,
        IMPORT_RENT_ADJUSTMENTS: `${apiUrl}/api/system/tools/rent-adjustments/import`,
        IMPORT_BULK_PORTFOLIO_DATA: '',
        SEND_WELCOME_MAILS: `${apiUrl}/api/system/tools/welcome-emails`,
    },
    Admin: {
        Corporations: {
            CORPORATIONS_LIST: `${apiUrl}/api/admin/corporations`,
            CURRENT_CORPORATION: `${apiUrl}/api/admin/corporations/current`,
            CORPORATION_CONFIGS: `${apiUrl}/api/admin/corporations/configs`,
        },
        Projects: {
            PROJECTS: `${apiUrl}/api/admin/projects`,
            SINGLE_PROJECT: (projectId: number) => `${apiUrl}/api/admin/projects/${projectId}`,
            PROJECT_CONTACT: (projectId: number) => `${apiUrl}/api/admin/projects/${projectId}/contact`,
            GET_BUILDING_MANAGER_SUGGESTIONS: (projectId: number) => `${apiUrl}/api/admin/projects/${projectId}/suggestions/managers`,
            PROJECT_CONFIGS: `${apiUrl}/api/admin/projects/configs`,
        },
        Buildings: {
            BUILDINGS: `${apiUrl}/api/admin/buildings`,
            SINGLE_BUILDING: (buildingId: number) => `${apiUrl}/api/admin/buildings/${buildingId}`,
            PROPERTY_MANAGER_SUGGESTIONS: (buildingId: number) => `${apiUrl}/api/admin/buildings/${buildingId}/suggestions/managers`,
        },
        Variants: {
            VARIANTS: `${apiUrl}/api/admin/variants`,
            SINGLE_VARIANT: (variantId: number) => `${apiUrl}/api/admin/variants/${variantId}`,
            VARIANT_MEDIA: (variantId: number) => `${apiUrl}/api/admin/variants/${variantId}/media`,
            VARIANT_MEDIA_PREVIEW: (variantId: number, mediaId: number) => `${apiUrl}/api/admin/variants/${variantId}/media/${mediaId}`,
            FLOOR_PLAN: (variantId: number) => `${apiUrl}/api/admin/variants/${variantId}/floor-plan`,
        },
        Properties: {
            PROPERTIES: `${apiUrl}/api/admin/properties`,
            SINGLE_PROPERTY: (propertyId: number) => `${apiUrl}/api/admin/properties/${propertyId}`,
            PROPERTY_COMPANIES: (propertyId: number) => `${apiUrl}/api/admin/properties/${propertyId}/companies`,
            TENANCY_PERIODS: (propertyId: number) => `${apiUrl}/api/admin/properties/${propertyId}/tenancy-periods`,
            TENANCY_PERIOD_ACTIVITY: (periodId: number) => `${apiUrl}/api/admin/properties/tenancy-periods/${periodId}/activity`,
            PROPERTY_FLOOR_PLAN: (propertyId: number) => `${apiUrl}/api/admin/properties/${propertyId}/floor-plan`,
            PROPERTY_DATES: (propertyId: number) => `${apiUrl}/api/admin/properties/${propertyId}/dates`,

            PROPERTY_NOTES: (propertyId: number) => `${apiUrl}/api/admin/properties/${propertyId}/notes`,
            SINGLE_NOTE: (propertyId: number, noteId: number) => `${apiUrl}/api/admin/properties/${propertyId}/notes/${noteId}`,
            PROPERTY_NOTE_MEDIA: (propertyId: number, noteId: number) => `${apiUrl}/api/admin/properties/${propertyId}/notes/${noteId}/media`,
        },
        PropertyGroupings: {
            GROUPINGS: `${apiUrl}/api/admin/groupings`,
            SINGLE_GROUPING: (groupingId: number) => `${apiUrl}/api/admin/groupings/${groupingId}`,
            GROUPING_TYPES: `${apiUrl}/api/admin/groupings/types`,
            UNIT_GROUPINGS: (unitId: number) => `${apiUrl}/api/admin/groupings/${unitId}/unit`,
            REMOVE_UNIT_FROM_GROUPING: (groupingId: number, unitId: number) => `${apiUrl}/api/admin/groupings/${groupingId}/units/${unitId}/delete`,

            // Unit grouping charts
            GROUPINGS_TENANTS: (groupingId: number) => `${apiUrl}/api/admin/groupings/${groupingId}/tenants`,
            GROUPING_RESIDENTS: (groupingId: number) => `${apiUrl}/api/admin/groupings/${groupingId}/residents`,
        },
        Documents: {
            DOCUMENTS: (search: any, column: string, dir: string, project: any) => {
                return `${apiUrl}/api/admin/documents?search=${search}&column=${column}&dir=${dir}&project=${project}`;
            },
            SINGLE_DOCUMENT: (id: number) => `${apiUrl}/api/admin/documents/${id}`,
            ADD_DOCUMENT: `${apiUrl}/api/admin/documents/document`,
            ADD_CONTRACT: `${apiUrl}/api/admin/documents/contract`,
            EDIT_DOCUMENT: (id: number) => `${apiUrl}/api/admin/documents/document/${id}`,
            EDIT_CONTRACT: (id: number) => `${apiUrl}/api/admin/documents/contract/${id}`,
            PREVIEW_MEDIA: (id: number) => `${apiUrl}/api/admin/documents/medias/${id}`,
            PREVIEW_DOCUMENT_MEDIA: (mediaId: number) => `${apiUrl}/api/admin/documents/medias/${mediaId}/preview`,
            FETCH_DOCUMENT_CATEGORIES: `${apiUrl}/api/admin/documents/categories`,
        },
        Staff: {
            SINGLE_STAFF: (id: number) => `${apiUrl}/api/admin/staff/${id}`,
            STAFF: `${apiUrl}/api/admin/staff`,
            STAFF_NOTIFICATIONS: `${apiUrl}/api/admin/staff/notifications`,
        },
        Tenants: {
            RESTORE_DELETED_MANAGEMENT_USER: (id: number) => `${apiUrl}/api/admin/tenants/restore/${id}`,
            TENANT: (tenantId) => `${apiUrl}/api/admin/tenants/${tenantId}`,
            TENANT_USERS: `${apiUrl}/api/admin/tenants`,
            DETACH_TENANT_FROM_UNIT: (tenantId: number, unitID: number) => `${apiUrl}/api/admin/tenants/detach/${unitID}/${tenantId}`,

            ADD_UPCOMING_TENANT: `${apiUrl}/api/admin/tenants/upcoming`,
            UPCOMING_TENANT: (propertyId: number, tenantId: number) => `${apiUrl}/api/admin/tenants/upcoming/${propertyId}/${tenantId}`,
            REVERT_UPCOMING_TENANT: (ownershipId: number) => `${apiUrl}/api/admin/tenants/upcoming/${ownershipId}/revert`,
            CANCEL_UPCOMING_TENANT_MOVE_IN: (ownershipId: number) => `${apiUrl}/api/admin/tenants/upcoming/${ownershipId}/cancel`,

            ADD_UPCOMING_GUEST: (propertyId: number) => `${apiUrl}/api/admin/properties/${propertyId}/guests`,
            UPCOMING_GUEST: (propertyId: number, guestId: number) => `${apiUrl}/api/admin/properties/${propertyId}/guests/${guestId}`,
            CANCEL_UPCOMING_GUEST_MOVE_IN: (propertyId: any, guestId: number) => `${apiUrl}/api/admin/properties/${propertyId}/guests/${guestId}/cancel`,

            PROFILE_PERSONAL_DETAILS: (tenantId: number) =>  `${apiUrl}/api/admin/tenants/profile/personal/${tenantId}`,
            PROFILE_DETAILS: (tenantId: number) =>  `${apiUrl}/api/admin/tenants/profile/profiling/${tenantId}`,
            PROFILE_APPLICATION_DETAILS: (applicationId: number) =>  `${apiUrl}/api/admin/tenants/profile/application/${applicationId}`,

            REASSIGN_TENANT: (unitId: number, userId: number) => `${apiUrl}/api/admin/tenants/${unitId}/${userId}/reassign`,

            APP_INVITATION: (projectId: number, userId: number) => `${apiUrl}/api/admin/projects/${projectId}/users/${userId}/send-app-invitation`,
        },
        Notifications: {
            NOTIFICATIONS: `${apiUrl}/api/admin/notifications`,
            SINGLE_NOTIFICATION: (notificationId: number) => `${apiUrl}/api/admin/notifications/${notificationId}`,
            NOTIFICATION_MEDIA: (notificationId: number) => `${apiUrl}/api/admin/notifications/${notificationId}/media`,
            GET_TARGETED_RECIPIENTS: () => `${apiUrl}/api/admin/notifications/recipients/targeted`,
        },
        Events: {
            EVENTS: `${apiUrl}/api/admin/events`,
            SINGLE_EVENT: (eventId: number) => `${apiUrl}/api/admin/events/${eventId}`,
            EVENT_MEDIA: (id: number) => `${apiUrl}/api/admin/events/${id}/media`,
            EVENT_ATTENDEES: (eventId: number) => `${apiUrl}/api/admin/events/${eventId}/attendees`,
        },
        EventLogs: {
            EVENT_LOGS: `${apiUrl}/api/admin/eventlogs/all`,
            EVENT_LOGS_UNSEEN: (page: number) => `${apiUrl}/api/admin/eventlogs/unseen?page=${page}`,
            EVENT_LOGS_UNSEEN_COUNT: `${apiUrl}/api/admin/eventlogs/unseen-count`,
            MARK_ALL_EVENT_LOGS_AS_SEEN: `${apiUrl}/api/admin/eventlogs/all/seen`,
            MAKE_EVENT_LOG_SEEN: (logId: number) => `${apiUrl}/api/admin/eventlog/${logId}/seen`,
        },
        Roles: {
            STAFF_ROLES: `${apiUrl}/api/admin/roles/staff`,
            PERMISSION_ROLES: `${apiUrl}/api/admin/permissions/roles`,
            PERMISSION_FEATURES: `${apiUrl}/api/admin/permissions/features`,
            ADD_ROLE: `${apiUrl}/api/admin/permissions/roles`,
            EDIT_ROLE: (roleId: number) => `${apiUrl}/api/admin/permissions/roles/${roleId}`,
            TOGGLE_PERMISSION_ROLE_FEATURE: (roleId: number) => `${apiUrl}/api/admin/permissions/roles/${roleId}`,
        },
        Tags: {
            SOCIAL_TAG: `${apiUrl}/api/admin/tags/social`,
            EDUCATIONAL_TAG: `${apiUrl}/api/admin/tags/educational`,
        },
        SharedFacilities: {
            ALL_FACILITY_TYPES: `${apiUrl}/api/admin/facility/types`,
            PROJECT_ALL_FACILITIES: (projectId: number) => `${apiUrl}/api/admin/projects/${projectId}/facilities`,
            ADD_NEW_FACILITY: (projectId: number) => `${apiUrl}/api/admin/projects/${projectId}/facilities`,
            ACTIVE_ADMIN_FACILITY_PHOTOS: (facilityId: number) => `${apiUrl}/api/admin/booking/facilities/${facilityId}/photos`,
            PHOTOS_TO_NEW_FACILITY: (facilityId: number) => `${apiUrl}/api/admin/booking/facilities/${facilityId}/photos`,
            ACTIVE_ADMIN_FACILITY_BOOKINGS: (facilityId: number) => `${apiUrl}/api/admin/booking/facilities/${facilityId}/bookings`,
            ACTIVE_ADMIN_FACILITY_BOOKINGS_SHEET: (facilityId: number) => `${apiUrl}/api/admin/booking/facilities/${facilityId}/bookings/sheet`,
            DELETE_ADMIN_ACTIVE_FACILITY: (facilityId: number) => `${apiUrl}/api/admin/booking/facilities/${facilityId}`,
            SINGLE_FACILITY: (facilityId: number) => `${apiUrl}/api/admin/booking/facilities/${facilityId}`,
            FACILITY_PHOTOS_FOR_UPDATE: (facilityId: number) => `${apiUrl}/api/admin/booking/facilities/${facilityId}/photos`,
            UPDATE_FACILITY_PHOTOS: (facilityId: number) => `${apiUrl}/api/admin/booking/facilities/${facilityId}/photos/update`,
            FACILITY_PHOTOS_ORDER: (facilityId: number) => `${apiUrl}/api/admin/booking/facilities/${facilityId}/photos/order`,
            CANCEL_RESERVATION: (bookingId: number) => `${apiUrl}/api/admin/booking/${bookingId}`,
            FACILITY_AVAILABLE: (facilityId: number, available: boolean) => `${apiUrl}/api/admin/booking/facilities/${facilityId}/available/${available}`,
            FACILITY_WATCHERS: `${apiUrl}/api/admin/facility/watchers`,
        },
        TicketsAttributes: {
            TICKET_ALL_TYPES: `${apiUrl}/api/admin/tickets/inquiries/types`,
            TICKET_ALL_CATEGORIES: (projectId: number, typeId: number, trash: boolean) => {
                return `${apiUrl}/api/admin/tickets/categories/${projectId}/${typeId}?deleted=${trash}`;
            },
            SINGLE_CATEGORY: (categoryId: number) => `${apiUrl}/api/admin/tickets/categories/${categoryId}`,
            TICKET_ROLE_ASSIGNEE: (projectId: number, categoryId: number, all: boolean) => {
                return `${apiUrl}/api/admin/tickets/categories/${projectId}/${categoryId}/assignable-users/${all}`;
            },
            TICKET_INQUIRIES: (typeId: number, category: number, projectId: number) => {
                return `${apiUrl}/api/admin/tickets/categories/${projectId}/${typeId}/${category}/inquiries`;
            },
            NEW_INQUIRY_CATEGORY: (projectId: number, typeId: number) => {
                return `${apiUrl}/api/admin/tickets/categories/${projectId}/${typeId}`;
            },
            SINGLE_INQUIRY_CATEGORY: (projectId: number, typeId: number, categoryId: number) => {
                return `${apiUrl}/api/admin/tickets/categories/${projectId}/${typeId}/${categoryId}`;
            },
            NEW_INQUIRY: (projectId: number, categoryId: number) => `${apiUrl}/api/admin/tickets/categories/${projectId}/${categoryId}/inquiries`,
            SINGLE_INQUIRY: (projectId: number, inquiryId: number) => `${apiUrl}/api/admin/tickets/inquiries/${projectId}/${inquiryId}`,
            INQUIRY_ROLE_ASSIGNEE: `${apiUrl}/api/admin/tickets/inquiries/roles`,
            INQUIRY_ROLE_ASSIGNEE_USERS: (projectId: number, roleId: number) => `${apiUrl}/api/admin/tickets/inquiries/roles/${projectId}/${roleId}/users`,
            UPDATE_INQUIRY_SORT: (projectId: number) => `${apiUrl}/api/admin/tickets/inquiries/${projectId}/sort-order`,
            UPDATE_INQUIRY_TYPE_SORT: `${apiUrl}/api/admin/tickets/inquiries/types/sort-order`,
            UPDATE_INQUIRY_CATEGORY_SORT: (projectId: number) => `${apiUrl}/api/admin/tickets/inquiries/categories/${projectId}/sort-order`,
        },
        TicketSystem: {
            TICKETS: (type: string) => `${apiUrl}/api/admin/tickets?type=${type}`,
            CURRENT_TICKET: (ticketId: number) => `${apiUrl}/api/admin/tickets/${ticketId}`,
            TICKET_ALL_STATES: `${apiUrl}/api/admin/tickets/states`,
            ADMIN_ADD_TICKET: `${apiUrl}/api/admin/tickets`,
            ADD_TICKET_PROPERTIES: (projectId: number) => `${apiUrl}/api/admin/tickets/properties/${projectId}`,
            ADD_TICKET_RECEIVERS: (propertyId: number) => `${apiUrl}/api/admin/tickets/receivers/${propertyId}`,
            FETCH_TICKET_CONVERSATION: (ticketId: number) => `${apiUrl}/api/admin/tickets/${ticketId}/conversation`,
            SEND_MESSAGE_TO_TICKET_USER: (ticketId: number) => `${apiUrl}/api/admin/tickets/${ticketId}/conversation/messages`,
            REMOVE_TICKET_MESSAGE: (ticketId: number, messageId: number) => `${apiUrl}/api/admin/tickets/${ticketId}/conversation/messages/${messageId}`,
            TICKET_SUGGESTED_WATCHERS: (projectId: number) => `${apiUrl}/api/admin/tickets/watchers/${projectId}`,
            TICKET_PRIORITY: (ticketId: number) => `${apiUrl}/api/admin/tickets/priority/${ticketId}`,
        },
        Profile: {
            ADMIN_ENDPOINT: `${apiUrl}/api/admin/user`,
            ADMIN_FETCH_TABLE_VIEW_LIST: () => `${apiUrl}/api/admin/user/table-views`,
            ADMIN_CREATE_TABLE_VIEW: () => `${apiUrl}/api/admin/user/table-views`,
            ADMIN_DELETE_TABLE_VIEW: (viewId: number) => `${apiUrl}/api/admin/user/table-views/${viewId}`,
            ADMIN_SAVE_TABLE_VIEW: (viewId: number) => `${apiUrl}/api/admin/user/table-views/${viewId}`,
        },
        Support: {
            SEND_CONTACT_US: `${apiUrl}/api/admin/contact-us`,
        },
        Integration: {
            CORPORATION_INTEGRATIONS: `${apiUrl}/api/admin/integrations`,
            INTEGRATION_DATA: (integrationId: number) => `${apiUrl}/api/admin/integrations/${integrationId}/data`,
            QUEUE_INTEGRATION_DATA_IMPORT: (integrationId: number, storageGuid: string) => {
                return apiUrl + '/api/admin/integrations/' + integrationId + '/data/' + storageGuid + '/import';
            },
        },
        Templates: {
            TEMPLATE_RENDERER: (templateId: any) => `${apiUrl}/api/admin/template-renderer/${templateId}/html401`,
        },
        WaitingList: {
            WAITING_LISTS: `${apiUrl}/api/admin/applications`,
            CURRENT_APPLICATION: (applicationId: number) => `${apiUrl}/api/admin/applications/${applicationId}`,
            APPLICATION_MASTER_DATA: (applicationId: number) => `${apiUrl}/api/admin/applications/${applicationId}/master-data`,
            TOGGLE_APPLICATION_ACTIVE: (applicationId: number, active: string) => `${apiUrl}/api/admin/applications/state/${applicationId}/${active}`,
            DECLINE_APPLICATION: (applicationId: number) => `${apiUrl}/api/admin/applications/${applicationId}/decline`,
            APPLICATION_EVENT_LOGS: (applicationId: number) => `${apiUrl}/api/admin/applications/${applicationId}/events`,
            APPLICATION_STATUS_SHEET: () => `${apiUrl}/api/admin/applications/statistics/status`,
            AVAILABLE_APARTMENTS: (applicationId: number, ignore: boolean) => `${apiUrl}/api/admin/applications/apartments/${applicationId}/${ignore}`,
            ASSIGN_UNIT: (applicationId: number, unitId: number) => `${apiUrl}/api/admin/applications/${applicationId}/unit/${unitId}/assign`,
            ACCEPT_APPLICATION: (applicationId: number, unitId: number) => `${apiUrl}/api/admin/applications/${applicationId}/unit/${unitId}/accept`,
            EXPIRATION_EMAIL: `${apiUrl}/api/admin/applications/emails/expiration`,
            OFFER_STATUS_REPORT: () => `${apiUrl}/api/admin/application/statistics/offer-status-report`,
        },
        PresentationFlow: {
            ASSIGN_TENANT: `${apiUrl}/api/admin/presentations/assign/tenant`,
            PRESENTATION_DEADLINE_REACHED: (presentationId: any) => `${apiUrl}/api/admin/presentations/deadline/${presentationId}`,
            PREVIEW_DOCUMENT: (documentId: number) => `${apiUrl}/api/admin/presentations/document/preview/${documentId}`,
            CURRENT_VACANT_UNIT: (unitId: number) => `${apiUrl}/api/admin/presentations/vacant/units/${unitId}`,
            ALL_VACANT_UNITS: `${apiUrl}/api/admin/presentations/vacant/units`,
            APPLICATIONS_FOR_PRESENTATION: (unitId: number, match: boolean, project: any, notActive: boolean = true, previouslyOffered: boolean = false) => {
                return  `${apiUrl}/api/admin/presentations?id=${unitId}&match=${match}&project=${project}&not-active=${notActive}&previously-offered=${previouslyOffered}`;
            },
            CURRENT_EDIT_PRESENTATION: (presentationId: number) => `${apiUrl}/api/admin/presentations/${presentationId}`,

            ALL_IN_PROGRESS_OFFERS: `${apiUrl}/api/admin/presentations/offers/in-progress`,
            ALL_DEADLINE_OFFERS: `${apiUrl}/api/admin/presentations/offers/deadline`,
            ALL_SENT_OFFERS: `${apiUrl}/api/admin/presentations/offers/sent`,
            ALL_COMPLETED_OFFERS: `${apiUrl}/api/admin/presentations/offers/completed`,
            CLOSED_OFFERS: `${apiUrl}/api/admin/presentations/offers/closed`,
            SEND_PRESENTATION_OFFER: `${apiUrl}/api/admin/presentations/offers/send`,
            SEND_PRESENTATION_EDIT_OFFER: `${apiUrl}/api/admin/presentations/offers/edit`,
            RE_OPEN_OFFER: (presentationId: number) => `${apiUrl}/api/admin/presentations/offers/reopen/${presentationId}`,
            COMPLETE_OFFER: `${apiUrl}/api/admin/presentations/offers/complete`,
            CLOSE_OFFER: (presentationId: number) => `${apiUrl}/api/admin/presentations/offers/close/${presentationId}`,
        },
        ConversationConvert: {
            CONVERT_TICKET_ALL_TYPES: `${apiUrl}/api/conversation/ticket-types`,
            CONVERT_TICKET_ALL_STATES: `${apiUrl}/api/conversation/ticket-states`,
            CONVERT_TICKET_ALL_WATCHERS: `${apiUrl}/api/conversation/ticket-watchers`,
            CONVERT_TICKET_ALL_CATEGORIES: (typeId: number, propertyId: number) => `${apiUrl}/api/conversation/ticket-categories/${typeId}/${propertyId}`,
            CONVERT_TICKET_ALL_ASSIGNEE: (categoryId: number) => `${apiUrl}/api/conversation/ticket-assignee/${categoryId}`,
            CONVERT_CONVERSATION_TICKET: (conversationId: number) => `${apiUrl}/api/conversation/convert-ticket/${conversationId}`,
        },
        Conversations: {
            CHECK_PROPERTY_CONVERSATION: (propertyID: number) => `${apiUrl}/api/conversation/check/for-property/${propertyID}`,
            ADD_DIRECT_CONVERSATION: (userId: number) => `${apiUrl}/api/conversation/add/direct/${userId}`,
            CHANGE_CONVERSATION_STATUS: (status: string, conversationId: number) => `${apiUrl}/api/conversation/change/${status}/${conversationId}`,
            CHANGE_CONVERSATION_TITLE: (conversationId: number) => `${apiUrl}/api/conversation/title/${conversationId}`,
            TOGGLE_PERSON_FOR_CONVERSATION: (conversationId: number) => `${apiUrl}/api/conversation/${conversationId}/participants`,
            SUGGESTED_STUFF_USERS: (conversationId: number, search: string) => `${apiUrl}/api/conversation/${conversationId}/suggested-stuff?search=${search}`,
            CONVERSATION_PDF_PREVIEW: (guid: number) => `${apiUrl}/api/conversation/attachment/${guid}`,
        },
        Localization: {
            ALL_LANGUAGES: `${apiUrl}/api/all-languages`,
            GLOBAL_CHANGE_LANGUAGE: (language: string) => `${apiUrl}/api/language/${language}/change`,

            LANGUAGE_TEXTS: `${apiUrl}/api/admin/localization/texts`,
            LANGUAGE_KEY: `${apiUrl}/api/admin/localization/key`,
            LANGUAGE_TEXT: `${apiUrl}/api/admin/localization/text`,
            ADD_LANGUAGE: `${apiUrl}/api/admin/localization/languages/add`,
            IMPORT_LANGUAGE_CSV: `${apiUrl}/api/localization/languages/csv`,
        },
        TextEditor: {
            STORE_TEXT_EDITOR_IMAGE: (type: string, sessionUUID: string) => `${apiUrl}/api/admin/quill/editor/images/${type}/store/${sessionUUID}`,
        },
        Countries: {
            COUNTRY: `${apiUrl}/api/admin/countries`,
        },
        OAUTH: {
            OAUTH_CLIENT_DATA: `${apiUrl}/api/oauth-client-data`,
        },
        Finances: {
            FETCH_CURRENCIES: `${apiUrl}/api/admin/finances/currencies`,
            FETCH_PAYMENT_PROVIDERS: `${apiUrl}/api/admin/finances/payment-providers`,
            FETCH_INTERVALS: `${apiUrl}/api/admin/finances/intervals`,
            FETCH_PAYMENT_ORDER_LINE_TYPES: `${apiUrl}/api/admin/finances/order-types`,

            FETCH_CREDITS_FINANCE_DATA: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/transactions`,
            FETCH_UNIT_ORDER_LINES: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/order-lines`,
            FETCH_UNIT_BALANCE_ACCOUNT_DATA: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/balance-account`,
            FETCH_PERIODICAL_CHARGES_FINANCE_DATA: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/recurring-orders`,
            FETCH_UNIT_ARREARS: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/arrears`,
            SAVE_NEW_DEPOSIT: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/deposit`,
            SAVE_NEW_REFUND: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/refund`,
            FETCH_UNIT_ORDERS: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/orders`,
            FETCH_UNIT_REFUNDABLE_ORDERS: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/orders/refundable`,
            FETCH_REFUNDS_FINANCE_DATA: (unitId: number) => `${apiUrl}/api/admin/finances/units/${unitId}/refunds`,

            FETCH_UNPAID_PAYMENTS_DATA: `${apiUrl}/api/admin/finances/corporations/orders/unpaid`,
            FETCH_CORPORATION_TRANSACTIONS_DATA: `${apiUrl}/api/admin/finances/corporations/transactions`,
            CONNECT_STRIPE_ACCOUNT_TO_CORPORATION: `${apiUrl}/api/admin/finances/corporations/stripe/connection`,
            CHECK_CORPORATION_STRIPE_CONNECTION_STATUS: `${apiUrl}/api/admin/finances/corporations/stripe/connection`,
            DISCONNECT_STRIPE_ACCOUNT_TO_CORPORATION: `${apiUrl}/api/admin/finances/corporations/stripe/connection`,

            ADD_RECURRING_ORDER: `${apiUrl}/api/admin/finances/recurring-orders/store`,
            PAUSE_PERIODICAL_CHARGE: (recurringOrderId: string) => `${apiUrl}/api/admin/finances/recurring-orders/${recurringOrderId}/status/update`,
            START_PERIODICAL_CHARGE: (recurringOrderId: string) => `${apiUrl}/api/admin/finances/recurring-orders/${recurringOrderId}/status/update`,
            UPDATE_PERIODICAL_CHARGE: (recurringOrderId: string) => `${apiUrl}/api/admin/finances/recurring-orders/${recurringOrderId}`,
            REMOVE_PERIODICAL_CHARGE: (recurringOrderId: string) => `${apiUrl}/api/admin/finances/recurring-orders/${recurringOrderId}`,

            ADD_ONE_TIME_ORDER: `${apiUrl}/api/admin/finances/orders/store`,
            REMOVE_ONE_TIME_CHARGE: (orderId: string) => `${apiUrl}/api/admin/finances/orders/${orderId}`,
        },
    },
    Users: {
        USER_ENDPOINT: `${apiUrl}/api/user`,
        VALIDATE_PIN: `${apiUrl}/api/user/pin/validate`,
        RESET_PIN: `${apiUrl}/api/user/pin/reset`,
        SET_PIN: `${apiUrl}/api/user/pin`,
        RESET_PASSWORD: `${apiUrl}/api/user/reset-password`,
        CHANGE_PASSWORD: `${apiUrl}/api/user/change-password`,
        FIREBASE_TOKEN: `${apiUrl}/api/user/firebase-token`,
        TRACK_ACTION: `${apiUrl}/api/user/actions`,
        DASHBOARD_ITEMS_PER_PAGE_COUNT: `${apiUrl}/api/user/dashboard/page-count`,
        USER_FEEDBACK: (eventId: number) => `${apiUrl}/api/user/feedback/${eventId}`,
        FEEDBACK_EVENTS: `${apiUrl}/api/feedback/events`,
        PROFILE_IMAGE: `${apiUrl}/api/user/profile-image`,
        MINIATURE: (userId: number) => `${apiUrl}/api/user/${userId}/profile-image/miniature`,
        USER_PROFILE_IMAGE: (userId: number, type: string) => `${apiUrl}/api/user/profile-image/${userId}/${type}`,
        AUTH_ENDPOINT: `${apiUrl}/oauth/token`,
        EULA_ENDPOINT: `${apiUrl}/api/user/eula`,
    },
    Tickets: {
        ALL_USER_TICKETS: (type: string) => `${apiUrl}/api/user/tickets/${type}`,
        USER_ADD_NEW_TICKET:  `${apiUrl}/api/user/tickets`,
        USER_INQUIRY_TYPES: `${apiUrl}/api/${currentVersion}/user/tickets/inquiries/types`,
        USER_INQUIRY_CATEGORIES: `${apiUrl}/api/${currentVersion}/user/tickets/inquiries/categories`,
        USER_INQUIRY_QUESTIONS: `${apiUrl}/api/${currentVersion}/user/tickets/inquiries`,
        USER_INQUIRY_ANSWER: (inquiryId: number) => `${apiUrl}/api/${currentVersion}/user/tickets/inquiries/${inquiryId}/answer`,

        USER_CURRENT_TICKET_TYPE: (typeId: number) => `${apiUrl}/api/user/ticket-type/${typeId}`,
        USER_CURRENT_TICKET_CATEGORY: (categoryId: number) => `${apiUrl}/api/user/ticket-category/${categoryId}`,
        USER_CURRENT_TICKET_INQUIRY: (inquiryId: number) => `${apiUrl}/api/user/ticket-inquiry/${inquiryId}`,
        USER_TICKET_ALL_CATEGORIES: (typeId: number) => `${apiUrl}/api/user/ticket-categories/${typeId}`,
        USER_TICKET_ALL_INQUIRIES: (typeId: number, categoryId: number) => `${apiUrl}/api/user/ticket-inquiries/${typeId}/${categoryId}`,
        USER_CURRENT_TICKET: (ticketId: number) => `${apiUrl}/api/user/ticket/${ticketId}`,
        USER_TICKET_CONVERSATION: (conversationId: number) => `${apiUrl}/api/user/ticket-conversation/${conversationId}`,
        USER_CANCEL_TICKET: (ticketId: number) => `${apiUrl}/api/user/cancel-ticket/${ticketId}`,
        USER_EDIT_TICKET_STATE: (ticketId: number) => `${apiUrl}/api/user/ticket-state/${ticketId}/update`,
        USER_EDIT_TICKET_ASSIGNEE: (ticketId: number) => `${apiUrl}/api/user/ticket-assignee/${ticketId}/update`,
        USER_TICKET_ALL_TYPES: `${apiUrl}/api/user/ticket-types`,
        TICKET_MESSAGE_TO_ADMIN: `${apiUrl}/api/user/ticket-message-to-admin`,
        TICKET_IMAGES: (ticketId: number) => `${apiUrl}/api/user/ticket/${ticketId}/images`,
        USER_TICKET_RESPONDED: (ticketId: number) => `${apiUrl}/api/user/ticket/${ticketId}/responded`,
        REMOVE_TICKET_IMAGE: (ticketId: number, imageId: number) => `${apiUrl}/api/user/ticket/${ticketId}/images/${imageId}`,
    },
    Identities: {
        IDENTITIES: `${apiUrl}/api/user/identities`,
        IDENTITIES_NOTIFICATIONS: `${apiUrl}/api/user/identities/notifications`,
    },
    Roles: {
        USER_ROLES: `${apiUrl}/api/user/roles`,
    },
    Suggestions: {
        USER_SUGGESTIONS: `${apiUrl}/api/user/suggestions`,
        ASSOCIATED_USERS_LIST: `${apiUrl}/api/user/associated-users`,
    },
    Versions: {
        LAST_VERSION: `${apiUrl}/api/user/version/last`,
        AVAILABLE_UPDATE_URL: (bundleId: string) => `${apiUrl}/api/user/version/url/${bundleId}`,
    },
    Likes: {
        USER_ADD_LIKE: `${apiUrl}/api/user/like`,
    },
    Options: {
        OPTION: `${apiUrl}/api/options`,
        OPTION_IMAGE_ORIGINAL: (guid: string) => `${apiUrl}/api/options/image/${guid}/original`,
        OPTION_IMAGE_THUMBNAIL: (guid: string) => `${apiUrl}/api/options/image/${guid}/thumbnail`,
        OPTION_IMAGE_LARGE: (guid: string) => `${apiUrl}/api/options/image/${guid}/large`,
        OPTION_IMAGE_POST: `${apiUrl}/api/options/images`,
    },
    Localization: {
        LOCALIZATION_DATA: (language: string) => `${apiUrl}/api/language/${language}/texts`,
    },
    Conversations: {
        CONVERSATION_LIST: `${apiUrl}/api/conversations`,
        CONVERSATION_UPDATES: (messageId: number) => `${apiUrl}/api/conversations/updates/after/${messageId}`,
        NOTIFICATION_COMMENTS: (notificationId: number) => `${apiUrl}/api/conversations/notification/${notificationId}`,
        CONVERSATION_DOWNLOAD_PDF: (guid: number) => `${apiUrl}/api/conversation/${guid}/download`,
        MESSAGE: (conversationId: number) => `${apiUrl}/api/conversation/${conversationId}/message`,
        REMOVE_MESSAGE: (conversationId: number, messageId: number) => `${apiUrl}/api/conversation/${conversationId}/message/${messageId}`,
        MESSAGE_PHOTO: (conversationId: number) => `${apiUrl}/api/conversation/${conversationId}/message/photo`,
        MESSAGE_LIST: (conversationId: number) => `${apiUrl}/api/conversation/${conversationId}/messages`,
        MARK_CONVERSATION_AS_SEEN: (conversationId: number, lastMessageId: number) => `${apiUrl}/api/conversation/${conversationId}/message/${lastMessageId}/seen`,
    },
    Tags: {
        FETCH_TAGS: (type: string) => `${apiUrl}/api/tags?type=${type}`,
    },
    Notifications: {
        NOTIFICATIONS_LIST: `${apiUrl}/api/user/notifications`,
        NOTIFICATIONS_UNREAD_COUNT: `${apiUrl}/api/${currentVersion}/user/notifications/unread`,
        DASHBOARD_NOTIFICATIONS: () => `${apiUrl}/api/${currentVersion}/user/notifications`,
        SHOW_TENANT_NOTIFICATION: (notificationId: number) => `${apiUrl}/api/${currentVersion}/user/notifications/show/${notificationId}`,
        TENANT_NOTIFICATIONS_LOGS: () => `${apiUrl}/api/${currentVersion}/user/notifications/logs`,
        TENANT_NOTIFICATIONS_READ_ALL: `${apiUrl}/api/${currentVersion}/user/notifications/read/all`,
        MARK_ACTIVE_NOTIFICATION_AS_SEEN: (notificationId: number) => `${apiUrl}/api/user/notifications/${notificationId}/seen`,
        USER_NOTIFICATION_MEDIA: (notificationId: number) => `${apiUrl}/api/user/notifications/${notificationId}/media`,

        EVENTS_LIST: `${apiUrl}/api/user/events`,
        TENANT_UPCOMING_EVENTS: `${apiUrl}/api/${currentVersion}/user/events/upcoming`,
        POST_USER_ATTENDING_CALENDAR_EVENT: (eventId: number) => `${apiUrl}/api/user/events/${eventId}/attending`,
        EVENT_USER_ATTENDEES: (eventId: number) => `${apiUrl}/api/user/events/${eventId}/attendees`,
    },
    Booking: {
        USER_FACILITIES_BOOKINGS: `${apiUrl}/api/booking`,
        USER_SHARED_FACILITIES: `${apiUrl}/api/booking/facilities`,
        CANCEL_USER_BOOKING: (bookingId: number) => `${apiUrl}/api/booking/${bookingId}`,
        ADD_USER_BOOKING: (facilityId: number) => `${apiUrl}/api/booking/facilities/${facilityId}`,
        SHARED_FACILITY_PHOTOS: (facilityId: number) => `${apiUrl}/api/booking/facilities/${facilityId}/photos`,
        FACILITY_UNAVAILABILITY: (facilityId: number, date: string = null) => {
            return (date === null)
                ? `${apiUrl}/api/booking/facilities/${facilityId}/bookings`
                : `${apiUrl}/api/booking/facilities/${facilityId}/bookings?date=${date}`;
        },
    },
    CorporationLinks: {
        USER_CORPORATION_LINKS: `${apiUrl}/api/corporation-links`,
    },
    Documents: {
        DOCUMENTS_LIST: (tab: string) => `${apiUrl}/api/${currentVersion}/documents/${tab}`,
        DOCUMENT_PREVIEW: (documentId: number) => `${apiUrl}/api/documents/${documentId}/preview`,
        DOCUMENT_DOWNLOAD_PDF: (documentId: number) => `${apiUrl}/api/documents/${documentId}/download`,
        DOCUMENT_DOWNLOAD_ZIP: `${apiUrl}/api/documents/download/zip`,
        MARK_ACTIVE_DOCUMENT_AS_SEEN: (documentId: number) => `${apiUrl}/api/user/documents/${documentId}/seen`,
        SIGN_DOCUMENT: (documentId: number) => `${apiUrl}/api/user/documents/${documentId}/sign`,
        ACTIVE_DOCUMENT: (id: number) => `${apiUrl}/api/${currentVersion}/document/${id}`,
    },
    Images: {
        IMAGE_ORIGINAL: (guid: string) => `${apiUrl}/api/image/${guid}/original`,
        IMAGE_LARGE: (guid: string) => `${apiUrl}/api/image/${guid}/large`,
        IMAGE_THUMBNAIL: (guid: string) => `${apiUrl}/api/image/${guid}/thumbnail`,
    },
    Attachments: {
        ATTACHMENT: `${apiUrl}/api/attachments`,
    },
    Properties: {
        PROPERTY: `${apiUrl}/api/properties`,
        STAFF_PROPERTIES: `${apiUrl}/api/janitor/properties`,
        STAFF_PROPERTY: (propertyId: number) => `${apiUrl}/api/janitor/properties/${propertyId}`,
    },
    Abuse: {
        REPORT_CONTENT: `${apiUrl}/api/abuse/content/reports`,
        BLOCK_CONTENT: `${apiUrl}/api/abuse/content/blockings`,
        HIDE_CONTENT: `${apiUrl}/api/abuse/content/hidings`,
    },
    Finances: {
        USER_CREDIT_CARDS: `${apiUrl}/api/user/finances/credit-cards`,
        ADD_USER_CREDIT_CARDS: `${apiUrl}/api/user/finances/credit-cards`,
        DELETE_USER_CREDIT_CARDS: (cardId: number) => `${apiUrl}/api/user/finances/credit-cards/${cardId}`,

        FETCH_STRIPE_PUBLIC_KEY: `${apiUrl}/api/user/finances/stripe/key`,
        FETCH_UPCOMING_PAYMENTS_DATA: `${apiUrl}/api/user/finances/upcoming-payments`,
        FETCH_ORDER_DETAILS: (orderId: any) => `${apiUrl}/api/user/finances/upcoming-payments/${orderId}`,
        PAY_FOR_ORDER: `${apiUrl}/api/user/finances/orders/pay-for`,

        GET_DEFAULT_PAYMENT_METHOD: `${apiUrl}/api/user/finances/payment-methods/default`,
        SET_DEFAULT_PAYMENT_METHOD: (paymentMethodId: any) => `${apiUrl}/api/user/finances/payment-methods/default/${paymentMethodId}`,

        USER_TRANSACTIONS: (type: any) => `${apiUrl}/api/user/finances/transactions/${type}`,
        FETCH_TRANSACTION: (transactionId: any) => `${apiUrl}/api/user/finances/transactions/details/${transactionId}`,
        USER_TRANSACTION_CANCEL: `${apiUrl}/api/user/finances/transactions/cancel`,
    },
    Channels: {
        USER_CHANNELS: `${apiUrl}/api/user/channels`,
        CHANNEL: (channelId) => `${apiUrl}/api/channels/${channelId}`,
        USER_CHANNEL: (channelId) => `${apiUrl}/api/user/channels/${channelId}`,
        JOIN_CHANNEL: (channelId) => `${apiUrl}/api/user/channels/${channelId}/join`,
        LEAVE_CHANNEL: (channelId) => `${apiUrl}/api/user/channels/${channelId}/leave`,
        CREATE_CHANNEL: `${apiUrl}/api/channels`,
        CHANNEL_MESSAGES: (channelId) => `${apiUrl}/api/user/channels/${channelId}/messages`,
        CHANNEL_MESSAGE: (channelId, messageId) => `${apiUrl}/api/user/channels/${channelId}/messages/${messageId}`,
        CHANNEL_NOTIFICATIONS: (channelId) => `${apiUrl}/api/user/channels/${channelId}/notifications`,
    },
};

export const Hococo = {
    CONVERSATION_UPDATE_INTERVAL: 5000, // ms
    SUGGESTION_DEBOUNCE_PERIOD: 500, // ms
};

export const UserTypes = {
    ADMINISTRATOR: 'administrator',
    EMPLOYEE: 'employee',
    PROPERTY_OWNER: 'property-owner',
    // TODO (Caspar): fix this
    STANDARD: 'standard',
    ADMIN: 'admin',
};

export const DocumentTypes = {
    CONTRACT: 'contract',
    DOCUMENT: 'document',
};

export const MessageActionTypes = {
    ADD_PARTICIPANT: 'add_participant',
    REMOVE_PARTICIPANT: 'remove_participant',
};

export const NotificationTypes = {
    Event: 'event',
    Document: 'document',
    Information: 'information',
    Contract: 'contract',
};

export const ID = {
    NEW_CONVERSATION: -1,

    NO_USER: -1,
};

export const InputConstraints = {
    MINIMUM_NAME_LENGTH: 2,
    MINIMUM_ADDRESS_LENGTH: 4,
    MINIMUM_COUNTRY_LENGTH: 2,
    MINIMUM_PHONENUMBER_LENGTH: 8,
    MAXIMIMUM_PHONENUMBER_LENGTH: 8,
    MINIMUM_CITY_LENGTH: 2,
    MINIMUM_ZIP_LENGTH: 4,
    MAXIMIMUM_ZIP_LENGTH: 4,
    MINIMUM_PASSWORD_LENGTH: 6,
    // PHONE_REGEX: '^([+][0-9]\d{0,10}[\s])?[0-9]{0,15}*$',
    // PHONE_REGEX: '/^\+?\d{2}[- ]?\d{3}[- ]?\d{5}$/',
    // ZIP_REGEX: /^\b\d{4}\s+[a-zA-Z]{2,20}\b/i,
    MONEY_REGEX: '^[0-9]+(\.[0-9]{1,2})?$',
    AREA_REGEX: '^[0-9- ]*$',
    PASSWORD_REGEX: '^[a-zA-Z0-9]+$',

};

export const InputValidators = {
    NAME: { required: true, min: InputConstraints.MINIMUM_NAME_LENGTH },
    EMAIL: { required: true, email: true },
    NULLABLE_EMAIL: { required: false, email: true },
    COUNTRY: { required: true, min: InputConstraints.MINIMUM_COUNTRY_LENGTH },
    ADDRESS: { required: true, min: InputConstraints.MINIMUM_ADDRESS_LENGTH },
    PHONENUMBER: { required: true, alpha: false },
    // ZIP: { required: true, regex: InputConstraints.ZIP_REGEX },
    ZIP: { required: true, min: InputConstraints.MINIMUM_ZIP_LENGTH, max: InputConstraints.MAXIMIMUM_ZIP_LENGTH },
    CITY: { required: true, min: InputConstraints.MINIMUM_CITY_LENGTH },
    PASSWORD: { required: true, min: InputConstraints.MINIMUM_PASSWORD_LENGTH, regex: InputConstraints.PASSWORD_REGEX },
    CONFIRM_PASSWORD: { required: true, confirmed: 'new-password' },
    REQUIRED: { required: true },
    NULLABLE: { required: false },
    REQUIREDNUMBER: {  numeric: true, required: true },
    REQUIREDALPHA: {  alpha: true, required: true },
    MONEY: { regex: InputConstraints.MONEY_REGEX, required: true },
    PDFDOCUMENTREQUIRED: { required: true, mimes: 'pdf' },
    PDFDOCUMENT: { mimes: 'pdf' },
    DATEBEFORE: { required: true, date_format: 'YYYY-MM-DD HH:mm', before: 'datePickerEnd' },
    IMAGEATTACHMENT: { mimes: ['image/png', 'image/jpg', 'image/jpeg']},
    AREA: { required: true, regex: InputConstraints.AREA_REGEX },
};

export const Views = {
    Admin: {
        Projects: 'Projects',
        Buildings: 'Buildings',
        Variants: 'Variants',
        Properties: 'Properties',
        Documents: 'Documents',
        UserManagement: 'UserManagement',
        Notifications: 'Notifications',
        MessageSystem: 'MessageSystem',
    },
    Home: 'home',
    Messages: 'messages',
    Notifications: 'Notifications',
    Events: 'Events',
    Documents: 'Documents',
    Options: 'Options',
    Profile: 'Profile',
    LogIn: 'LogIn',
    Contacts: 'Contacts',
    Tickets: 'Tickets',
};

export const ViewModes = {
    Messages: {
        Conversations: 'Conversations',
        Messages: 'Messages',
        AddPerson: 'AddPerson',
        Participants: 'Participants',
        FullScreenImage: 'FullScreenImage',
    },
    Notifications: {
        All: 'All',
        DocumentView: 'DocumentView',
        EventView: 'EventView',
        InformationView: 'InformationView',
        ContractView: 'ContractView',
        SingleNotification: 'SingleNotification',
        GeneralNotification: 'GeneralNotification',
        Attachments: 'Attachments',
    },
    Events: {
        All: 'All',
        SingleEventView: 'SingleEventView',
        EventListView: 'EventListView',
    },
    Documents: {
        All: 'All',
        ContractView: 'ContractView',
        PendingView: 'PendingView',
        AttachmentView: 'AttachmentView',
        isSignedView: 'isSignedView',
    },
    Options: {
        All: 'All',
        SingleOptionView: 'SingleOptionView',
        YourOptionsView: 'YourOptionsView',
    },
    Profile: {
        Profile: 'Profile',
        EditProfile: 'EditProfile',
        Attachment: 'Attachment',

    },
    LogIn: {
        LogInView: 'LogInView',
        ErrorView: 'ErrorView',
    },
    // Contacts: {
    //     All: 'Contacts',
    // },
};

export const Tabs = {
    Notifications: {
        All: 'All',
        Important: 'Important',
        Events: 'Events',
    },
    Events: {
        All: 'All',
        Important: 'Important',
        NotImportant: 'NotImportant',
    },
    Documents: {
        Pending: 'Pending',
        All: 'All',
        Documents: 'Documents',
        Contracts: 'Contracts',
        Signature: 'Signature',
    },
};

export const OverlayMods = {
    PreviewBooking: {
        none: '',
        viewCongrats: 'view-congrats',
        viewActive: 'view-active',
        viewPrevious: 'view-previous',
        deleted: 'deleted',
    },
};

export const Buttons = {
    AddParticipantButton: 'AddParticipantButton',
    HococoAddButton: 'HococoAddButton',
    BackButton: 'BackButton',
    StaffBackButton: 'StaffBackButton',
    StaffLanguageButton: 'StaffLanguageButton',
    StaffUnitButton: 'StaffUnitButton',
    HococoButton: 'HococoButton',
    HococoDownloadButton: 'HococoDownloadButton',
    EventCalendarButton: 'EventCalendarButton',
    EventListButton: 'EventListButton',
    UserProfileButton: 'UserProfileButton',
    HandButton: 'HandButton',
    TenantDashboardButtons: 'TenantDashboardButtons',
    CorporationLogo: 'CorporationLogo',
    AbuseButton: 'AbuseButton',
    None: '',
};

export const FormModes = {
    Create: 'create',
    Edit: 'edit',
    Delete: 'delete',
    Preview: 'preview',
};

export const Tags = {
    IMPORTANT: 'important',
};

export const ImageCropperTargets = {
    ProfileImage: 'ProfileImage',
};

export const PinDialogModes = {
    SET_PIN: 'set-pin',
    ENTER_PIN: 'enter-pin',
};

export const Constants = {
    Hococo,
    Actions,
    Mutations,
    OAuth,
    Endpoints,
    UserTypes,
    MessageActionTypes,
    ID,
    InputConstraints,
    InputValidators,
    ViewModes,
    Buttons,
    Tabs,
    NotificationTypes,
    Tags,
    ImageCropperTargets,
};

export default Constants;

